var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 117,
    viewBox: "0 0 61 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_2843)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1549 56.1646H23.469L4.71875 1.86133H9.40469L28.1549 56.1646Z",
    fill: "url(#paint0_linear_840_2843)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8424 56.1646H28.1565L9.40625 1.86133H14.0922L32.8424 56.1646Z",
    fill: "url(#paint1_linear_840_2843)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5299 56.1646H32.844L14.0938 1.86133H18.7797L37.5299 56.1646Z",
    fill: "url(#paint2_linear_840_2843)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.7766 1.86133H14.0906H9.40472H4.71875L23.469 56.1646H28.1549H32.8409H37.5268L18.7766 1.86133Z",
    fill: "url(#paint3_linear_840_2843)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.321 61.8215H20.5859V56.6799C20.5859 55.0332 21.9729 53.6934 23.6775 53.6934H37.2294C38.934 53.6934 40.321 55.0332 40.321 56.6799V61.8215ZM22.2124 60.2504H38.6945V56.6799C38.6945 55.8995 38.0372 55.2646 37.2294 55.2646H23.6775C22.8697 55.2646 22.2124 55.8995 22.2124 56.6799V60.2504Z",
    fill: "url(#paint4_linear_840_2843)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7744 61.8194H20.1562V56.2145C20.1562 54.4195 21.6168 52.959 23.4118 52.959H37.5189C39.3139 52.959 40.7744 54.4195 40.7744 56.2145L40.7744 61.8194ZM21.869 60.1067H39.0617V56.2145C39.0617 55.3638 38.3696 54.6717 37.5189 54.6717H23.4118C22.5611 54.6717 21.869 55.3638 21.869 56.2145L21.869 60.1067Z",
    fill: "url(#paint5_linear_840_2843)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.783 61.8318L38.5826 61.8595L36.3907 61.873L32.0069 61.8944C30.5457 61.9084 26.0015 61.8886 24.5402 61.8851L20.1564 61.8624L20.1172 61.8622L20.1174 61.8233C20.1253 60.471 20.1349 59.1187 20.1239 57.7663L20.1196 56.7521C20.1203 56.4151 20.1029 56.0748 20.1548 55.7351C20.2435 55.0523 20.5723 54.4139 21.0434 53.9165C21.5196 53.422 22.1509 53.0753 22.8306 52.9541C23.1705 52.8825 23.5182 52.9001 23.8527 52.8937L24.867 52.8876L32.0069 52.8754L36.064 52.875L37.0782 52.8761C37.2492 52.8778 37.412 52.873 37.5896 52.8801L37.8429 52.8932L38.1032 52.9315C38.7903 53.0526 39.4241 53.4028 39.904 53.9005C40.3787 54.4006 40.708 55.0463 40.7956 55.731C40.8474 56.0743 40.829 56.4161 40.8291 56.7521L40.8227 57.7664L40.783 61.8318ZM40.7659 61.8147L40.7263 57.7664L40.72 56.7521C40.7158 56.4131 40.729 56.0746 40.675 55.7489C40.5826 55.0907 40.2578 54.4758 39.7982 54.0034C39.3343 53.5328 38.7231 53.2094 38.0754 53.1009L37.8341 53.0651L37.5809 53.0525C37.4208 53.0462 37.2453 53.0511 37.0782 53.0498L36.064 53.0509L32.0069 53.0505L24.867 53.0383L23.8527 53.0322C23.513 53.0344 23.1782 53.0133 22.8527 53.0783C22.1977 53.1868 21.5839 53.5135 21.1163 53.9873C20.6531 54.4625 20.3278 55.0847 20.2363 55.7448C20.1825 56.074 20.1966 56.414 20.1931 56.7521L20.1888 57.7663C20.1778 59.1187 20.1874 60.471 20.1953 61.8233L20.1564 61.7844L24.5402 61.7617C26.0015 61.7582 30.5457 61.7384 32.0069 61.7523L36.3907 61.7737L38.5826 61.7873L40.7659 61.8147Z",
    fill: "url(#paint6_linear_840_2843)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8696 60.0994C23.0426 60.0775 24.2155 60.0603 25.3884 60.0571L31.9987 60.0342C33.1746 60.029 34.3504 60.0459 35.5262 60.0506L39.0536 60.0753L39.0208 60.108C39.0334 59.1225 39.0212 58.137 39.0169 57.1515L39.0128 56.4123C39.0185 56.162 39.0043 55.9246 38.9152 55.7003C38.7521 55.2499 38.3535 54.8947 37.8927 54.7808C37.6642 54.7167 37.4217 54.7354 37.1728 54.7351L36.4336 54.741L34.9554 54.7514L31.9987 54.7623L25.9592 54.7606L24.4809 54.7574L23.7418 54.7513C23.4966 54.751 23.2479 54.7335 23.0259 54.7962C22.5698 54.9085 22.1762 55.2603 22.0131 55.7054C21.9241 55.9292 21.9093 56.1623 21.9144 56.4123L21.9082 57.1515L21.8696 60.0994ZM21.8525 60.1165L21.8137 57.1515L21.8075 56.4123C21.7979 56.1712 21.809 55.9026 21.9013 55.6641C22.0696 55.1802 22.4895 54.7895 22.9889 54.6571C23.2445 54.5827 23.4962 54.6 23.7418 54.595L24.4809 54.5888L25.9592 54.5856L31.9987 54.584L34.9554 54.5949L36.4336 54.6053L37.1728 54.6112C37.4147 54.6157 37.6725 54.5995 37.9216 54.6725C38.4164 54.8033 38.8313 55.1905 38.9996 55.6692C39.0917 55.907 39.1035 56.1715 39.0945 56.4123L39.0903 57.1515C39.0861 58.137 39.0738 59.1225 39.0864 60.108L39.0869 60.1407L39.0536 60.1409L35.5262 60.1656C34.3504 60.1703 33.1746 60.1872 31.9987 60.1819L25.3884 60.1591C24.2126 60.1559 23.0368 60.1386 21.861 60.1166L21.8525 60.1165Z",
    fill: "url(#paint7_linear_840_2843)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7446 106.75C61.9274 95.5674 61.9274 77.4365 50.7446 66.2537C39.5619 55.071 21.431 55.071 10.2482 66.2537C-0.934568 77.4365 -0.93457 95.5674 10.2482 106.75C21.431 117.933 39.5619 117.933 50.7446 106.75Z",
    fill: "url(#paint8_linear_840_2843)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2901 106.294C61.221 95.3631 61.221 77.6408 50.2901 66.7099C39.3593 55.7791 21.6369 55.7791 10.7061 66.7099C-0.224745 77.6408 -0.224746 95.3631 10.7061 106.294C21.6369 117.225 39.3593 117.225 50.2901 106.294Z",
    fill: "url(#paint9_linear_840_2843)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4883 86.4998C58.4883 86.4998 58.4844 86.6716 58.4769 87.0043C58.4626 87.3368 58.4762 87.8312 58.4165 88.4737C58.3363 89.758 58.1327 91.6504 57.4921 93.9733C57.4101 94.2629 57.3259 94.5602 57.2396 94.8651C57.1388 95.1655 57.0355 95.4734 56.9298 95.7887C56.8306 96.1064 56.7012 96.4213 56.5748 96.7453C56.4459 97.0684 56.3263 97.4036 56.1705 97.7315C55.6011 99.0664 54.861 100.458 53.944 101.863C52.1142 104.667 49.5194 107.53 46.0844 109.845C44.3674 110.996 42.4504 112.007 40.3667 112.803C40.1098 112.912 39.8408 112.992 39.5758 113.086C39.3094 113.175 39.0436 113.271 38.7726 113.354C38.4998 113.431 38.2259 113.508 37.9509 113.586L37.5376 113.702L37.1178 113.8C36.8372 113.864 36.5555 113.929 36.2727 113.993C35.9897 114.056 35.7011 114.098 35.414 114.151C34.8404 114.265 34.2553 114.33 33.6674 114.403C33.3741 114.446 33.077 114.462 32.7797 114.485C32.4823 114.506 32.1839 114.527 31.8845 114.549C31.5845 114.556 31.2835 114.563 30.9815 114.57L30.5279 114.58C30.3721 114.58 30.2244 114.573 30.0719 114.57C29.7692 114.562 29.4654 114.554 29.1608 114.545C28.856 114.533 28.5495 114.501 28.2426 114.48C27.6267 114.445 27.0155 114.351 26.3985 114.274C25.1712 114.078 23.9348 113.836 22.7196 113.469C22.1054 113.308 21.5082 113.083 20.9008 112.881C20.601 112.769 20.3045 112.646 20.0051 112.529L19.5566 112.351L19.1162 112.15C16.7551 111.104 14.5104 109.695 12.4761 107.988C11.4556 107.137 10.508 106.191 9.60552 105.198C8.70663 104.2 7.89745 103.117 7.13428 101.999C6.37722 100.875 5.71964 99.681 5.12483 98.4541C4.53363 97.2239 4.05648 95.938 3.64536 94.6306C3.2398 93.3199 2.95654 91.9722 2.73995 90.6144C2.53692 89.2524 2.44959 87.8783 2.42969 86.4979C2.44383 85.1267 2.52557 83.7442 2.72312 82.3824C2.93424 81.0229 3.2122 79.6727 3.61283 78.3588C4.01903 77.0482 4.49164 75.7582 5.07883 74.5234C5.66961 73.2918 6.32369 72.0926 7.07792 70.9629C10.075 66.4263 14.367 62.8944 19.0977 60.8071L19.5391 60.6074L19.9887 60.4295C20.2887 60.3126 20.5859 60.1902 20.8864 60.0787C21.4951 59.8777 22.0935 59.653 22.7088 59.4929C23.9262 59.1271 25.1648 58.8865 26.3937 58.6929C27.0115 58.617 27.6241 58.523 28.2392 58.4897C28.5463 58.4689 28.8519 58.437 29.1576 58.4256C29.4635 58.4177 29.7685 58.4099 30.0725 58.4021C30.2258 58.3992 30.3736 58.3922 30.5308 58.3926L30.9829 58.4039C31.2839 58.4114 31.5839 58.4189 31.8829 58.4263C32.183 58.4482 32.4822 58.47 32.7803 58.4918C33.0784 58.5153 33.3766 58.5312 33.6698 58.5749C34.258 58.6493 34.8434 58.7151 35.4172 58.8298C35.7044 58.8839 35.993 58.926 36.2762 58.9895C36.559 59.0547 36.8408 59.1196 37.1215 59.1843L37.5413 59.2826L37.9546 59.3998C38.2296 59.4778 38.5036 59.5555 38.7764 59.6329C39.0473 59.7166 39.3132 59.8124 39.5797 59.9023C39.8446 59.9966 40.1138 60.076 40.3707 60.1854C42.4548 60.9833 44.372 61.9956 46.0888 63.1477C49.5237 65.465 52.1166 68.3303 53.9458 71.1352C54.8628 72.5402 55.6027 73.932 56.1719 75.2671C56.3277 75.5951 56.4473 75.9303 56.5762 76.2534C56.7025 76.5775 56.8319 76.8924 56.931 77.2101C57.0367 77.5254 57.14 77.8334 57.2407 78.1338C57.327 78.4387 57.4111 78.7361 57.4931 79.0256C58.1334 81.3486 58.3368 83.2415 58.4167 84.5252C58.4763 85.1674 58.4628 85.6625 58.4769 85.995C58.4844 86.3278 58.4883 86.4998 58.4883 86.4998ZM58.4641 86.4995C58.4641 86.4995 58.4593 86.328 58.45 85.9955C58.434 85.6633 58.4449 85.1687 58.3818 84.5277C58.295 83.246 58.0815 81.357 57.4299 79.043C57.3466 78.7547 57.2611 78.4586 57.1734 78.1549C57.0712 77.8557 56.9666 77.5492 56.8594 77.2353C56.7589 76.919 56.6281 76.6056 56.5004 76.2832C56.3701 75.9617 56.2491 75.6283 56.0919 75.3021C55.5173 73.9744 54.7723 72.5915 53.8514 71.1972C52.0134 68.4137 49.4108 65.583 45.9838 63.3045C44.2706 62.172 42.3607 61.1806 40.2886 60.4036C38.218 59.6235 35.9781 59.0847 33.6431 58.8115C33.3519 58.7678 33.058 58.7521 32.7636 58.7286C32.469 58.7068 32.1735 58.685 31.8769 58.6631C31.5779 58.6554 31.2779 58.6477 30.9769 58.64L30.5248 58.6284C30.3801 58.628 30.2255 58.6348 30.076 58.6377C29.7744 58.6452 29.4719 58.6527 29.1685 58.6603C28.8653 58.6714 28.5622 58.7029 28.2577 58.7233C27.6476 58.7558 27.0401 58.8488 26.4274 58.9235C25.2085 59.1148 23.9801 59.3523 22.7725 59.7145C22.1621 59.8727 21.5686 60.0953 20.9647 60.2941C20.6666 60.4045 20.3718 60.5258 20.0741 60.6414L19.6281 60.8175L19.1901 61.0153C16.8417 62.0491 14.6073 63.4436 12.5805 65.1359C11.5637 65.9794 10.6191 66.9178 9.71898 67.9031C8.82287 68.894 8.01367 69.968 7.25443 71.0803C6.5004 72.1978 5.84541 73.3852 5.25267 74.6055C4.66351 75.829 4.18791 77.1082 3.77783 78.4087C3.37329 79.7126 3.09055 81.0535 2.87392 82.4045C2.67089 83.7602 2.58316 85.125 2.5621 86.5013C2.57741 87.8685 2.65954 89.2417 2.85711 90.5971C3.06823 91.9499 3.3457 93.2932 3.74532 94.6003C4.15047 95.9042 4.62153 97.1873 5.20665 98.4155C5.79538 99.6404 6.44687 100.833 7.19807 101.956C10.1879 106.465 14.4674 109.963 19.1715 112.026L19.6106 112.223L20.0576 112.399C20.356 112.514 20.6515 112.635 20.9502 112.745C21.5555 112.943 22.1502 113.165 22.7617 113.322C23.9716 113.683 25.202 113.919 26.4226 114.108C27.0361 114.182 27.6449 114.274 28.2544 114.306C28.559 114.326 28.8612 114.357 29.1653 114.367C29.47 114.374 29.7737 114.381 30.0765 114.389C30.2269 114.391 30.3816 114.398 30.5276 114.397L30.9783 114.385C31.2782 114.377 31.5772 114.368 31.8753 114.36C32.1726 114.338 32.4689 114.316 32.7642 114.293C33.0594 114.269 33.3544 114.253 33.6454 114.209C35.9821 113.932 38.2216 113.387 40.2927 112.606C42.3652 111.828 44.2751 110.835 45.9882 109.701C49.4151 107.42 52.0158 104.587 53.8533 101.803C54.7741 100.409 55.5189 99.0256 56.0934 97.6978C56.2505 97.3716 56.3714 97.038 56.5017 96.7166C56.6294 96.3941 56.7602 96.0807 56.8606 95.7644C56.9677 95.4505 57.0724 95.1439 57.1745 94.8447C57.2622 94.541 57.3477 94.2449 57.4309 93.9564C58.0822 91.6424 58.2954 89.753 58.3821 88.4718C58.445 87.8311 58.4341 87.3358 58.45 87.0036C58.4593 86.671 58.4641 86.4995 58.4641 86.4995Z",
    fill: "url(#paint10_linear_840_2843)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M43.7366 61.1125C39.7744 59.0406 35.2679 57.8672 30.4868 57.8672C14.672 57.8672 1.85156 70.6876 1.85156 86.5025C1.85156 95.0973 5.63906 102.807 11.635 108.055C11.9972 107.959 12.3579 107.861 12.7149 107.757C18.5423 106.065 23.9087 102.815 28.1357 98.4643C35.2332 91.1593 37.3503 81.1738 40.0861 71.6875C41.0804 68.2401 42.233 64.5964 43.7366 61.1125Z",
    fill: "url(#paint11_linear_840_2843)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5016 111.103C44.0896 111.103 55.1048 100.088 55.1048 86.4997C55.1048 72.9117 44.0896 61.8965 30.5016 61.8965C16.9137 61.8965 5.89844 72.9117 5.89844 86.4997C5.89844 100.088 16.9137 111.103 30.5016 111.103Z",
    fill: "url(#paint12_linear_840_2843)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4971 110.459C43.7288 110.459 54.4552 99.7327 54.4552 86.501C54.4552 73.2694 43.7288 62.543 30.4971 62.543C17.2654 62.543 6.53906 73.2694 6.53906 86.501C6.53906 99.7327 17.2654 110.459 30.4971 110.459Z",
    fill: "url(#paint13_linear_840_2843)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1128 86.5016C55.1128 86.5016 55.1094 86.6527 55.1029 86.9451C55.0905 87.2374 55.1026 87.6719 55.0503 88.2368C54.9802 89.3658 54.8019 91.0295 54.2394 93.0718C54.1674 93.3264 54.0935 93.5878 54.0177 93.8558C53.9292 94.12 53.8385 94.3907 53.7456 94.6679C53.6585 94.9473 53.5449 95.2242 53.4339 95.5091C53.3206 95.7931 53.2156 96.0879 53.0787 96.3762C52.5785 97.5501 51.9283 98.7738 51.1224 100.009C49.5145 102.475 47.2341 104.994 44.2142 107.031C42.7048 108.043 41.0193 108.933 39.187 109.634C38.9612 109.73 38.7246 109.8 38.4916 109.883C38.2574 109.962 38.0236 110.046 37.7852 110.119C37.5453 110.186 37.3044 110.254 37.0625 110.322C36.8214 110.393 36.5778 110.459 36.3298 110.511C36.083 110.567 35.8352 110.624 35.5865 110.68C35.3376 110.736 35.0838 110.772 34.8313 110.819C34.3269 110.919 33.8123 110.976 33.2952 111.04C33.0373 111.078 32.7761 111.092 32.5146 111.112C32.253 111.13 31.9906 111.149 31.7274 111.168C31.4635 111.174 31.1988 111.18 30.9332 111.186L30.5343 111.195C30.3968 111.195 30.2674 111.189 30.1333 111.186C29.8671 111.179 29.6001 111.172 29.3324 111.164C29.0644 111.154 28.7947 111.125 28.5248 111.106C27.9831 111.076 27.4457 110.992 26.9031 110.925C25.824 110.753 24.7368 110.539 23.6683 110.216C23.1283 110.075 22.6032 109.876 22.0692 109.699C21.8056 109.6 21.5449 109.492 21.2817 109.389L20.8874 109.232L20.5002 109.056C18.4243 108.135 16.451 106.896 14.6629 105.394C13.7659 104.646 12.933 103.814 12.1399 102.94C11.3497 102.063 10.639 101.11 9.96761 100.128C9.30179 99.1398 8.72342 98.0903 8.20022 97.0117C7.68021 95.9303 7.26041 94.7997 6.89869 93.6503C6.54183 92.4981 6.2925 91.3131 6.10178 90.1193C5.92299 88.9225 5.84593 87.7122 5.82812 86.5014C5.84017 85.2931 5.91162 84.0793 6.08496 82.8811C6.2702 81.6856 6.51424 80.4983 6.86615 79.3427C7.22297 78.1901 7.63821 77.0555 8.15421 75.9695C8.67341 74.8862 9.24826 73.8314 9.91124 72.8377C12.5464 68.8474 16.3213 65.7413 20.4816 63.9053L20.8699 63.7296L21.2653 63.5731C21.5291 63.4703 21.7905 63.3627 22.0548 63.2646C22.5901 63.0878 23.1164 62.8901 23.6576 62.7493C24.7283 62.4275 25.8175 62.2158 26.8983 62.0455C27.4417 61.9788 27.9804 61.8961 28.5215 61.8668C28.7915 61.8484 29.0603 61.8204 29.3291 61.8103C29.5982 61.8034 29.8664 61.7965 30.1339 61.7896C30.2688 61.7871 30.3983 61.7809 30.5372 61.7813L30.9346 61.7912C31.1992 61.7977 31.4629 61.8043 31.7257 61.8109C31.9898 61.8301 32.2529 61.8493 32.5152 61.8684C32.7774 61.889 33.0398 61.9031 33.2976 61.9415C35.3676 62.186 37.3598 62.6505 39.191 63.3582C41.0237 64.0608 42.7093 64.9519 44.2186 65.9657C47.2384 68.0049 49.5169 70.5256 51.1243 72.9925C51.93 74.2281 52.5801 75.452 53.0801 76.626C53.217 76.9144 53.322 77.2092 53.4352 77.4933C53.5462 77.7782 53.6598 78.0551 53.7468 78.3345C53.8396 78.6117 53.9304 78.8825 54.0188 79.1467C54.0946 79.4148 54.1684 79.6762 54.2404 79.9308C54.8025 81.9732 54.9807 83.6373 55.0506 84.7658C55.1027 85.3303 55.0907 85.7656 55.103 86.0579C55.1095 86.3504 55.1128 86.5016 55.1128 86.5016ZM55.0886 86.5013C55.0886 86.5013 55.0843 86.3506 55.076 86.0583C55.0619 85.7664 55.0713 85.3317 55.0157 84.7683C54.9389 83.6418 54.7506 81.9816 54.1772 79.9482C54.1039 79.6948 54.0287 79.4346 53.9515 79.1677C53.8616 78.9049 53.7695 78.6355 53.6752 78.3597C53.5868 78.0817 53.4717 77.8064 53.3594 77.523C53.2448 77.2406 53.1384 76.9476 53.0001 76.661C52.4947 75.4944 51.8396 74.2794 51.0298 73.0545C49.4137 70.6091 47.1255 68.123 44.1136 66.1226C42.6079 65.1283 40.9296 64.2581 39.109 63.5764C37.2897 62.8921 35.3223 62.4179 33.2709 62.178C33.0151 62.1397 32.757 62.1258 32.4985 62.1052C32.2397 62.0861 31.9802 62.0669 31.7197 62.0476C31.4569 62.0409 31.1932 62.0341 30.9286 62.0273L30.5312 62.0171L30.1373 62.0252C29.8723 62.0318 29.6066 62.0384 29.3401 62.045C29.0737 62.0548 28.8075 62.0825 28.54 62.1004C28.004 62.1288 27.4703 62.2106 26.932 62.2762C25.8613 62.4441 24.7821 62.6528 23.7212 62.9708C23.185 63.1098 22.6636 63.3053 22.133 63.48C21.8712 63.5769 21.6121 63.6835 21.3507 63.785L20.9588 63.9397L20.5741 64.1135C18.511 65.0216 16.5479 66.2466 14.7673 67.7332C13.874 68.4741 13.0441 69.2985 12.2533 70.1641C11.4659 71.0345 10.7552 71.9781 10.0878 72.9551C9.42497 73.9366 8.84919 74.9796 8.32805 76.0516C7.81008 77.1263 7.39184 78.25 7.03114 79.3926C6.67532 80.5381 6.42651 81.7162 6.23576 82.9033C6.05697 84.0937 5.97948 85.2947 5.96059 86.5014C5.97371 87.7058 6.04562 88.9103 6.21895 90.1021C6.4042 91.2908 6.64773 92.4714 6.99862 93.6201C7.3544 94.7659 7.76809 95.8937 8.28203 96.9731C8.79915 98.0496 9.37147 99.0979 10.0314 100.085C12.6592 104.048 16.4217 107.12 20.5555 108.931L20.9413 109.105L21.3342 109.259C21.5964 109.36 21.8561 109.466 22.1186 109.563C22.6505 109.736 23.1731 109.931 23.7105 110.07C24.7736 110.386 25.8548 110.593 26.9273 110.759C27.4663 110.824 28.0013 110.905 28.5366 110.932C28.8043 110.95 29.0696 110.977 29.3369 110.986C29.6047 110.992 29.8717 110.999 30.1379 111.005C30.2699 111.007 30.4063 111.013 30.5341 111.012L30.93 111.001C31.1936 110.994 31.4562 110.987 31.7181 110.979C31.9793 110.96 32.2396 110.94 32.4991 110.92C32.7584 110.899 33.0176 110.885 33.2733 110.846C35.3262 110.603 37.2932 110.123 39.113 109.437C40.934 108.754 42.6124 107.882 44.118 106.887C47.1298 104.884 49.4161 102.396 51.0317 99.9496C51.8413 98.7245 52.4963 97.5093 53.0016 96.3425C53.1398 96.0559 53.2461 95.7628 53.3607 95.4804C53.473 95.197 53.5881 94.9216 53.6764 94.6436C53.7707 94.3678 53.8628 94.0984 53.9526 93.8355C54.0297 93.5686 54.105 93.3084 54.1782 93.0549C54.7513 91.0214 54.9393 89.3608 55.0159 88.2349C55.0714 87.6718 55.062 87.2364 55.0761 86.9444C55.0844 86.6521 55.0886 86.5013 55.0886 86.5013Z",
    fill: "url(#paint14_linear_840_2843)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1469 56.1646H23.4609L42.2112 1.86133H46.8971L28.1469 56.1646Z",
    fill: "url(#paint15_linear_840_2843)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8344 56.1646H28.1484L46.8986 1.86133H51.5846L32.8344 56.1646Z",
    fill: "url(#paint16_linear_840_2843)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5219 56.1646H32.8359L51.5862 1.86133H56.2721L37.5219 56.1646Z",
    fill: "url(#paint17_linear_840_2843)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M51.583 1.86133H46.8971H42.2112L23.4609 56.1646H28.1469H32.8328H37.5188L56.269 1.86133H51.583Z",
    fill: "url(#paint18_linear_840_2843)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0703 107.951C24.3847 107.929 24.654 107.887 24.8846 107.83C25.1168 107.768 25.3143 107.676 25.4767 107.585C25.8025 107.399 25.9983 107.182 26.1152 106.964C26.347 106.528 26.2728 106.092 26.2183 105.877C25.954 106.056 25.5309 106.409 25.057 106.948C25.057 106.948 25.1227 106.793 25.2785 106.568C25.4349 106.34 25.6843 106.029 26.0353 105.726C25.9235 105.722 25.7536 105.727 25.5588 105.77C25.3664 105.805 25.1516 105.867 24.9415 106.005C24.5269 106.279 24.1133 106.828 24.0703 107.951Z",
    fill: "url(#paint19_linear_840_2843)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7975 102.504C25.9695 102.684 26.1128 102.86 26.2311 103.03C26.351 103.195 26.4497 103.34 26.5236 103.49C26.6725 103.784 26.7318 104.06 26.7327 104.305C26.7367 104.796 26.4978 105.16 26.3509 105.328C26.2034 105.045 26.0021 104.58 25.9319 103.871C25.9319 103.871 25.9015 104.038 25.9066 104.315C25.9132 104.589 25.9588 104.961 26.122 105.385C26.0224 105.34 25.8765 105.263 25.7329 105.142C25.5918 105.011 25.4564 104.826 25.3707 104.595C25.1952 104.128 25.2484 103.463 25.7975 102.504Z",
    fill: "url(#paint20_linear_840_2843)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3047 106.889C22.581 106.925 23.1731 106.579 23.461 106.184C23.7471 105.785 23.7318 105.34 23.7083 105.114C23.4243 105.253 22.9699 105.52 22.4252 106.001C22.4252 106.001 22.5111 105.855 22.6967 105.649C22.8818 105.443 23.1663 105.177 23.5501 104.932C23.3328 104.885 22.8856 104.836 22.4282 105.065C21.9755 105.295 21.4901 105.792 21.3047 106.889Z",
    fill: "url(#paint21_linear_840_2843)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7239 101.719C24.3303 102.482 24.479 103.143 24.4138 103.633C24.3525 104.121 24.0687 104.449 23.9033 104.591C23.7959 104.286 23.6686 103.772 23.6884 103.068C23.6884 103.068 23.6366 103.229 23.6068 103.501C23.5774 103.773 23.5702 104.157 23.6724 104.608C23.4904 104.485 23.1442 104.197 23.0304 103.726C22.912 103.253 23.0486 102.608 23.7239 101.719Z",
    fill: "url(#paint22_linear_840_2843)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7344 105.462C19.0438 105.521 19.3149 105.55 19.5526 105.554C19.7894 105.56 20.0068 105.518 20.1863 105.474C20.5493 105.379 20.7949 105.22 20.9645 105.04C21.3018 104.679 21.3437 104.239 21.3469 104.017C21.0458 104.12 20.5427 104.356 19.9483 104.748C19.9483 104.748 20.0522 104.615 20.2613 104.438C20.468 104.264 20.7922 104.025 21.2094 103.824C21.1026 103.791 20.9367 103.753 20.7381 103.743C20.546 103.721 20.32 103.73 20.0817 103.807C19.6094 103.966 19.0675 104.389 18.7344 105.462Z",
    fill: "url(#paint23_linear_840_2843)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8128 100.646C21.9329 100.864 22.0261 101.071 22.0965 101.266C22.166 101.462 22.2263 101.623 22.258 101.788C22.3253 102.112 22.3108 102.394 22.248 102.63C22.1243 103.105 21.7987 103.394 21.6131 103.519C21.5451 103.205 21.4689 102.709 21.5888 102C21.5888 102 21.5161 102.153 21.4491 102.422C21.3806 102.695 21.3306 103.061 21.3773 103.514C21.2928 103.445 21.1713 103.333 21.065 103.177C20.9654 103.01 20.8802 102.801 20.8579 102.554C20.8091 102.059 21.0328 101.43 21.8128 100.646Z",
    fill: "url(#paint24_linear_840_2843)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3438 103.723C17.5687 104.084 18.2313 103.901 18.612 103.594C18.9906 103.284 19.0935 102.848 19.128 102.625C18.8172 102.686 18.3081 102.828 17.6569 103.152C17.6569 103.152 17.7779 103.033 18.0106 102.882C18.2429 102.731 18.5869 102.547 19.0219 102.409C18.8235 102.308 18.4031 102.147 17.9015 102.25C17.3996 102.361 16.82 102.696 16.3438 103.723Z",
    fill: "url(#paint25_linear_840_2843)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0324 99.3574C20.4245 100.25 20.3982 100.925 20.2088 101.38C20.0214 101.838 19.6646 102.078 19.4667 102.174C19.4414 101.852 19.4508 101.324 19.6511 100.65C19.6511 100.65 19.5596 100.792 19.4606 101.046C19.362 101.301 19.2562 101.67 19.2387 102.131C19.0941 101.966 18.833 101.6 18.8441 101.117C18.8472 100.635 19.1631 100.026 20.0324 99.3574Z",
    fill: "url(#paint26_linear_840_2843)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2422 101.672C15.3664 102.231 16.089 102.093 16.5043 101.84C16.9237 101.578 17.0774 101.164 17.1372 100.952C16.8167 100.976 16.2731 101.071 15.6015 101.293C15.6015 101.293 15.7363 101.191 15.9843 101.074C16.1083 101.015 16.26 100.952 16.4367 100.895C16.6179 100.833 16.8248 100.775 17.0535 100.73C16.8539 100.621 16.472 100.393 15.9713 100.42C15.4727 100.453 14.8394 100.723 14.2422 101.672Z",
    fill: "url(#paint27_linear_840_2843)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4567 97.8184C18.6862 98.7961 18.6148 99.4197 18.3656 99.8486C18.1241 100.275 17.7341 100.471 17.5222 100.544C17.5345 100.226 17.5919 99.7245 17.8941 99.0664C17.8941 99.0664 17.7845 99.1957 17.6509 99.4377C17.5842 99.5588 17.5115 99.7086 17.4453 99.8852C17.3837 100.057 17.3294 100.256 17.2949 100.479C17.1571 100.313 16.9597 99.9023 17.0435 99.4148C17.1226 98.9248 17.4997 98.3757 18.4567 97.8184Z",
    fill: "url(#paint28_linear_840_2843)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3984 99.3839C13.4813 100.053 14.1799 100.04 14.6245 99.8424C15.0707 99.6399 15.2818 99.2454 15.3718 99.0399C15.0548 99.0195 14.5249 99.0263 13.8107 99.1733C13.8107 99.1733 13.9583 99.0894 14.2225 99.0029C14.4864 98.9161 14.8669 98.8265 15.324 98.8042C15.1572 98.6567 14.7905 98.3938 14.2777 98.3656C13.7699 98.3402 13.1271 98.511 12.3984 99.3839Z",
    fill: "url(#paint29_linear_840_2843)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0875 96.1133C17.2284 97.0815 17.0406 97.719 16.7379 98.1118C16.4395 98.5058 16.0322 98.6461 15.8159 98.6881C15.8731 98.3718 16.0167 97.8647 16.3825 97.2663C16.3825 97.2663 16.2576 97.3796 16.0968 97.6C15.9362 97.8207 15.7398 98.1487 15.6054 98.5891C15.5071 98.3932 15.3471 97.9737 15.4807 97.5107C15.6136 97.042 16.0794 96.5326 17.0875 96.1133Z",
    fill: "url(#paint30_linear_840_2843)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 96.8585C11.3613 97.2659 11.7572 97.5003 12.1218 97.5973C12.486 97.6944 12.7795 97.6781 13.0168 97.6064C13.4903 97.4609 13.7447 97.1011 13.8568 96.9114C13.6967 96.8832 13.4822 96.8554 13.2153 96.842C12.9533 96.8259 12.6491 96.8179 12.2893 96.8422C12.2893 96.8422 12.4459 96.7786 12.7162 96.7291C12.9902 96.6768 13.3592 96.6491 13.8319 96.6766C13.6642 96.5213 13.37 96.1928 12.8701 96.0953C12.3785 95.9989 11.6959 96.0959 10.875 96.8585Z",
    fill: "url(#paint31_linear_840_2843)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.951 94.2266C15.951 94.7185 15.8613 95.1297 15.7614 95.4417C15.661 95.7542 15.5092 95.9904 15.3374 96.1638C14.9949 96.5127 14.5666 96.6025 14.3426 96.6184C14.3875 96.4679 14.459 96.2735 14.5729 96.0494C14.6918 95.8223 14.8636 95.5599 15.0876 95.2849C15.0876 95.2849 14.9484 95.3814 14.7572 95.5805C14.5702 95.7777 14.3128 96.0888 14.1386 96.4979C14.0453 96.3037 13.9764 95.8469 14.1743 95.4028C14.3759 94.9507 14.8814 94.5185 15.951 94.2266Z",
    fill: "url(#paint32_linear_840_2843)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69531 94.1638C10.5595 95.0958 11.2489 95.2596 11.727 95.1852C12.211 95.105 12.5163 94.7788 12.6561 94.6037C12.3543 94.5023 11.8395 94.372 11.1102 94.3289C11.1102 94.3289 11.2746 94.2862 11.5526 94.2711C11.8304 94.2557 12.2218 94.2676 12.6702 94.3641C12.5463 94.1787 12.2585 93.8305 11.7692 93.6706C11.2966 93.51 10.6222 93.511 9.69531 94.1638Z",
    fill: "url(#paint33_linear_840_2843)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.049 92.2207C14.9249 93.1938 14.589 93.7564 14.1925 94.0583C13.8027 94.3613 13.3724 94.3917 13.1522 94.3764C13.2886 94.0861 13.5575 93.6342 14.0648 93.1518C14.0648 93.1518 13.9149 93.2289 13.7027 93.3998C13.4907 93.5711 13.2166 93.8366 12.9737 94.2266C12.9287 94.0123 12.8811 93.5665 13.129 93.1547C13.3903 92.7325 13.9633 92.3653 15.049 92.2207Z",
    fill: "url(#paint34_linear_840_2843)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 91.3289C9.23736 91.8496 9.56385 92.1777 9.88404 92.3683C10.2113 92.5569 10.4993 92.6175 10.7473 92.61C11.2427 92.5926 11.5814 92.3114 11.7387 92.1576C11.5915 92.0887 11.3903 92.0063 11.1367 91.9237C10.8941 91.8382 10.5978 91.7525 10.2453 91.6818C10.2453 91.6818 10.4131 91.6612 10.687 91.6838C10.967 91.7042 11.327 91.7746 11.7751 91.9245C11.6585 91.7297 11.4573 91.3366 11.0003 91.1121C10.5505 90.8909 9.86597 90.8066 8.875 91.3289Z",
    fill: "url(#paint35_linear_840_2843)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4548 90.1074C14.3255 90.5823 14.1371 90.9546 13.9527 91.2314C13.7751 91.5064 13.5674 91.6948 13.3566 91.8175C12.9354 92.065 12.4981 92.0406 12.2774 91.9977C12.3598 91.8641 12.4782 91.6954 12.6473 91.5085C12.8272 91.3187 13.0568 91.1113 13.346 90.9039C13.346 90.9039 13.1865 90.9607 12.9501 91.1031C12.72 91.2443 12.3869 91.4786 12.1111 91.8285C12.0764 91.6154 12.1261 91.157 12.4332 90.7799C12.7453 90.396 13.3458 90.1107 14.4548 90.1074Z",
    fill: "url(#paint36_linear_840_2843)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 88.4155C9.02927 89.5381 9.6445 89.8769 10.1275 89.9293C10.6154 89.978 10.9955 89.7427 11.1763 89.6101C10.9116 89.4335 10.449 89.1735 9.75661 88.9422C9.75661 88.9422 9.92644 88.9437 10.1986 89.0015C10.4707 89.0589 10.8452 89.1724 11.2526 89.3823C11.1816 89.1711 10.9952 88.7598 10.5648 88.4781C10.1408 88.2009 9.49802 88.0267 8.42969 88.4155Z",
    fill: "url(#paint37_linear_840_2843)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1168 87.9369C13.7517 88.8449 13.2733 89.3011 12.8138 89.4892C12.3584 89.6802 11.9353 89.5973 11.7268 89.5251C11.9344 89.2803 12.3122 88.914 12.9281 88.5801C12.9281 88.5801 12.7632 88.6155 12.5138 88.7253C12.2644 88.8356 11.9303 89.0206 11.5938 89.334C11.6065 89.1153 11.6773 88.6723 12.0244 88.3391C12.3771 88.0004 13.0344 87.7931 14.1168 87.9369Z",
    fill: "url(#paint38_linear_840_2843)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36719 85.4766C8.7854 86.6657 9.38534 87.0796 9.86115 87.1944C10.3435 87.3059 10.7444 87.1222 10.9367 87.0143C10.6898 86.805 10.243 86.4878 9.60533 86.1694C9.60533 86.1694 9.77292 86.1927 10.0325 86.2852C10.2902 86.3771 10.6412 86.5379 11.0334 86.7986C10.9702 86.5803 10.8586 86.1485 10.4786 85.8139C10.0984 85.4844 9.45699 85.2277 8.36719 85.4766Z",
    fill: "url(#paint39_linear_840_2843)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0735 85.7346C13.5626 86.5905 13.0631 86.9802 12.5868 87.1071C12.1153 87.2372 11.7 87.1001 11.4984 87.0016C11.7287 86.786 12.1289 86.472 12.8018 86.2201C12.8018 86.2201 12.6332 86.2339 12.3688 86.3106C12.1025 86.3878 11.7417 86.5282 11.3828 86.795C11.4036 86.5801 11.5512 86.1501 11.9488 85.8644C12.3467 85.5736 12.9988 85.4515 14.0735 85.7346Z",
    fill: "url(#paint40_linear_840_2843)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6875 82.5521C8.96479 83.7903 9.46957 84.274 9.93734 84.4505C10.4012 84.6233 10.8225 84.4928 11.0272 84.4105C10.8006 84.1702 10.4379 83.8024 9.82935 83.4014C9.82935 83.4014 9.99279 83.4464 10.2395 83.5719C10.4864 83.697 10.8167 83.9024 11.1521 84.2092C11.1414 83.9874 11.074 83.543 10.7356 83.161C10.3983 82.7844 9.81436 82.4489 8.6875 82.5521Z",
    fill: "url(#paint41_linear_840_2843)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3049 83.544C14.0032 83.9341 13.714 84.2107 13.4274 84.3952C13.1458 84.5806 12.8891 84.6767 12.6446 84.7093C12.1602 84.7776 11.7662 84.5881 11.5791 84.4644C11.8265 84.2792 12.3033 84.0242 12.9855 83.8598C12.9855 83.8598 12.8168 83.8517 12.5461 83.8936C12.2753 83.936 11.9023 84.0288 11.4922 84.2447C11.5643 84.0371 11.7537 83.6281 12.18 83.3959C12.6091 83.1589 13.2899 83.1267 14.3049 83.544Z",
    fill: "url(#paint42_linear_840_2843)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39062 79.6895C9.42667 80.3162 9.58502 80.7744 9.76098 81.0979C9.93994 81.4221 10.1536 81.617 10.3697 81.7336C10.805 81.9652 11.2417 81.8912 11.4607 81.8378C11.283 81.5736 10.9539 81.1569 10.4015 80.6788C10.4015 80.6788 10.558 80.7449 10.7877 80.9022C11.0175 81.059 11.3207 81.3068 11.6178 81.6562C11.6381 81.4355 11.6031 80.9786 11.3379 80.5613C11.062 80.1463 10.513 79.7323 9.39062 79.6895Z",
    fill: "url(#paint43_linear_840_2843)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8397 81.4151C14.4725 81.7568 14.1626 81.9963 13.8583 82.1426C13.5566 82.2898 13.277 82.3482 13.0304 82.3486C12.5393 82.3523 12.1753 82.1135 12.0114 81.9677C12.2963 81.8204 12.7847 81.6256 13.4808 81.5517C13.4808 81.5517 13.315 81.5215 13.0427 81.528C12.7702 81.5349 12.3911 81.5787 11.9609 81.7403C12.0614 81.5445 12.2764 81.1564 12.7495 80.9881C13.2151 80.8123 13.8799 80.8654 14.8397 81.4151Z",
    fill: "url(#paint44_linear_840_2843)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4685 76.9414C10.4019 78.2046 10.7851 78.8123 11.1792 79.1C11.5801 79.3867 12.0237 79.3712 12.2444 79.3457C12.1004 79.0594 11.8149 78.5973 11.3461 78.0575C11.3461 78.0575 11.4919 78.1434 11.6962 78.3284C11.8987 78.512 12.1632 78.7959 12.4199 79.1847C12.4517 78.9612 12.5109 78.5184 12.2889 78.0637C12.064 77.6132 11.5704 77.1291 10.4685 76.9414Z",
    fill: "url(#paint45_linear_840_2843)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6367 79.3693C14.8425 79.9626 14.2192 80.1264 13.7292 80.0608C13.2417 79.9998 12.9131 79.7156 12.7664 79.5481C13.0657 79.4385 13.5614 79.3039 14.2771 79.3289C14.2771 79.3289 14.1161 79.2769 13.8425 79.2464C13.5668 79.2154 13.1817 79.2075 12.7422 79.3144C12.8501 79.1263 13.1482 78.7844 13.6253 78.6735C14.104 78.5577 14.7525 78.6959 15.6367 79.3693Z",
    fill: "url(#paint46_linear_840_2843)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8997 74.3652C11.6767 75.6121 11.9575 76.2544 12.3197 76.596C12.6819 76.9341 13.1206 76.9753 13.3408 76.9779C13.2312 76.6729 13.0318 76.1905 12.6239 75.586C12.6239 75.586 12.7576 75.6904 12.9375 75.9015C13.1177 76.1121 13.3444 76.4292 13.5374 76.8423C13.6119 76.6328 13.7178 76.195 13.5513 75.7118C13.3957 75.2412 12.9747 74.7003 11.8997 74.3652Z",
    fill: "url(#paint47_linear_840_2843)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7025 77.4471C15.8449 77.9361 15.1861 78.0066 14.7181 77.8821C14.2451 77.759 13.9536 77.4324 13.8281 77.246C14.1349 77.1744 14.6671 77.1189 15.3596 77.2292C15.3596 77.2292 15.2072 77.1569 14.9416 77.0917C14.6758 77.027 14.2966 76.9697 13.8364 77.0121C13.9818 76.8476 14.3111 76.5413 14.793 76.4903C15.2911 76.4434 15.9213 76.6683 16.7025 77.4471Z",
    fill: "url(#paint48_linear_840_2843)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6507 71.9941C13.5535 72.295 13.4917 72.5616 13.4582 72.7981C13.4299 73.0387 13.4329 73.2516 13.4537 73.4358C13.4965 73.8051 13.6201 74.0679 13.7753 74.2589C14.0871 74.639 14.5208 74.7401 14.7414 74.7734C14.6788 74.4613 14.5264 73.9436 14.2056 73.2953C14.2056 73.2953 14.3239 73.4156 14.4732 73.647C14.626 73.8805 14.8122 74.2264 14.9544 74.6647C15.0028 74.5643 15.066 74.4074 15.1032 74.2127C15.1427 74.0198 15.1658 73.796 15.1171 73.5475C15.0187 73.0562 14.6683 72.4624 13.6507 71.9941Z",
    fill: "url(#paint49_linear_840_2843)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0096 75.6788C17.7802 75.7716 17.565 75.8388 17.3642 75.8847C17.1686 75.9346 16.9905 75.9654 16.8234 75.9758C16.49 75.9976 16.2105 75.9449 15.9831 75.851C15.5271 75.665 15.2849 75.3062 15.1875 75.107C15.5073 75.0805 16.0246 75.0815 16.7019 75.2849C16.7019 75.2849 16.5595 75.1928 16.303 75.0923C16.0494 74.9947 15.6836 74.8906 15.2265 74.8763C15.3074 74.8025 15.4374 74.6993 15.6072 74.6152C15.7793 74.5328 16.0002 74.4772 16.2447 74.4851C16.7394 74.4989 17.3318 74.801 18.0096 75.6788Z",
    fill: "url(#paint50_linear_840_2843)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5012 71.2695C16.894 71.4495 16.4783 71.6802 16.1971 71.9133C15.9154 72.1585 15.7669 72.4132 15.6958 72.6495C15.5557 73.1236 15.7153 73.5357 15.8115 73.7347C16.0354 73.4943 16.3773 73.0988 16.7345 72.4679C16.7345 72.4679 16.701 72.6341 16.5931 72.8888C16.4855 73.1449 16.304 73.4842 16.021 73.8454C16.2418 73.814 16.6801 73.7209 17.0374 73.356C17.3896 72.9917 17.6829 72.3865 17.5012 71.2695Z",
    fill: "url(#paint51_linear_840_2843)"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8594 107.951C24.1737 107.929 24.443 107.887 24.6736 107.83C24.9059 107.768 25.1034 107.676 25.2657 107.585C25.5916 107.399 25.7873 107.182 25.9043 106.964C26.136 106.528 26.0619 106.092 26.0074 105.877C25.7431 106.056 25.32 106.409 24.846 106.948C24.846 106.948 24.9118 106.793 25.0676 106.568C25.2239 106.34 25.4733 106.029 25.8243 105.726C25.7125 105.722 25.5427 105.727 25.3478 105.77C25.1555 105.805 24.9407 105.867 24.7306 106.005C24.316 106.279 23.9023 106.828 23.8594 107.951Z",
    fill: "url(#paint52_linear_840_2843)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5788 102.504C25.7508 102.684 25.8941 102.86 26.0124 103.03C26.1323 103.195 26.231 103.34 26.3048 103.49C26.4538 103.784 26.5131 104.06 26.5139 104.305C26.5179 104.796 26.2791 105.16 26.1321 105.328C25.9847 105.045 25.7834 104.58 25.7132 103.871C25.7132 103.871 25.6828 104.038 25.6879 104.315C25.6944 104.589 25.74 104.961 25.9033 105.385C25.8037 105.34 25.6577 105.263 25.5141 105.142C25.3731 105.011 25.2377 104.826 25.152 104.595C24.9765 104.128 25.0296 103.463 25.5788 102.504Z",
    fill: "url(#paint53_linear_840_2843)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1094 106.889C22.3857 106.925 22.9778 106.579 23.2656 106.184C23.5518 105.785 23.5365 105.34 23.513 105.114C23.229 105.253 22.7745 105.52 22.2298 106.001C22.2298 106.001 22.3158 105.855 22.5014 105.649C22.6865 105.443 22.9709 105.177 23.3548 104.932C23.1375 104.885 22.6903 104.836 22.2329 105.065C21.7801 105.295 21.2948 105.792 21.1094 106.889Z",
    fill: "url(#paint54_linear_840_2843)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5285 101.719C24.135 102.482 24.2837 103.143 24.2185 103.633C24.1572 104.121 23.8734 104.449 23.708 104.591C23.6005 104.286 23.4733 103.772 23.493 103.068C23.493 103.068 23.4413 103.229 23.4115 103.501C23.3821 103.773 23.3749 104.157 23.4771 104.608C23.2951 104.485 22.9488 104.197 22.8351 103.726C22.7167 103.253 22.8533 102.608 23.5285 101.719Z",
    fill: "url(#paint55_linear_840_2843)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5391 105.462C18.8484 105.521 19.1196 105.55 19.3572 105.554C19.5941 105.56 19.8115 105.518 19.991 105.474C20.354 105.379 20.5996 105.22 20.7692 105.04C21.1065 104.679 21.1484 104.239 21.1516 104.017C20.8505 104.12 20.3474 104.356 19.753 104.748C19.753 104.748 19.8569 104.615 20.066 104.438C20.2726 104.264 20.5969 104.025 21.014 103.824C20.9073 103.791 20.7414 103.753 20.5427 103.743C20.3507 103.721 20.1247 103.73 19.8864 103.807C19.4141 103.966 18.8722 104.389 18.5391 105.462Z",
    fill: "url(#paint56_linear_840_2843)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6253 100.646C21.7454 100.864 21.8386 101.071 21.909 101.266C21.9785 101.462 22.0388 101.623 22.0705 101.788C22.1378 102.112 22.1233 102.394 22.0604 102.63C21.9368 103.105 21.6112 103.394 21.4255 103.519C21.3576 103.205 21.2814 102.709 21.4013 102C21.4013 102 21.3286 102.153 21.2616 102.422C21.1931 102.695 21.1431 103.061 21.1898 103.514C21.1053 103.445 20.9838 103.333 20.8775 103.177C20.7779 103.01 20.6927 102.801 20.6704 102.554C20.6216 102.059 20.8453 101.43 21.6253 100.646Z",
    fill: "url(#paint57_linear_840_2843)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1484 103.723C17.3734 104.084 18.036 103.901 18.4167 103.594C18.7952 103.284 18.8982 102.848 18.9326 102.625C18.6219 102.686 18.1128 102.828 17.4616 103.152C17.4616 103.152 17.5825 103.033 17.8153 102.882C18.0476 102.731 18.3916 102.547 18.8266 102.409C18.6282 102.308 18.2078 102.147 17.7062 102.25C17.2043 102.361 16.6247 102.696 16.1484 103.723Z",
    fill: "url(#paint58_linear_840_2843)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8371 99.3574C20.2291 100.25 20.2029 100.925 20.0134 101.38C19.8261 101.838 19.4693 102.078 19.2714 102.174C19.2461 101.852 19.2555 101.324 19.4558 100.65C19.4558 100.65 19.3643 100.792 19.2653 101.046C19.1667 101.301 19.0608 101.67 19.0434 102.131C18.8988 101.966 18.6377 101.6 18.6488 101.117C18.6519 100.635 18.9678 100.026 19.8371 99.3574Z",
    fill: "url(#paint59_linear_840_2843)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0391 101.672C15.1633 102.231 15.8859 102.093 16.3012 101.84C16.7206 101.578 16.8743 101.164 16.9341 100.952C16.6136 100.976 16.07 101.071 15.3984 101.293C15.3984 101.293 15.5332 101.191 15.7812 101.074C15.9052 101.015 16.0569 100.952 16.2336 100.895C16.4148 100.833 16.6217 100.775 16.8503 100.73C16.6508 100.621 16.2688 100.393 15.7682 100.42C15.2696 100.453 14.6363 100.723 14.0391 101.672Z",
    fill: "url(#paint60_linear_840_2843)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2614 97.8184C18.4909 98.7961 18.4195 99.4197 18.1703 99.8486C17.9288 100.275 17.5388 100.471 17.3269 100.544C17.3392 100.226 17.3966 99.7245 17.6988 99.0664C17.6988 99.0664 17.5891 99.1957 17.4555 99.4377C17.3889 99.5588 17.3162 99.7086 17.25 99.8852C17.1884 100.057 17.134 100.256 17.0996 100.479C16.9618 100.313 16.7644 99.9023 16.8482 99.4148C16.9273 98.9248 17.3044 98.3757 18.2614 97.8184Z",
    fill: "url(#paint61_linear_840_2843)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 99.3839C13.2704 100.053 13.9689 100.04 14.4136 99.8424C14.8598 99.6399 15.0708 99.2454 15.1609 99.0399C14.8438 99.0195 14.314 99.0263 13.5997 99.1733C13.5997 99.1733 13.7473 99.0894 14.0115 99.0029C14.2754 98.9161 14.6559 98.8265 15.1131 98.8042C14.9462 98.6567 14.5795 98.3938 14.0667 98.3656C13.5589 98.3402 12.9161 98.511 12.1875 99.3839Z",
    fill: "url(#paint62_linear_840_2843)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8765 96.1133C17.0175 97.0815 16.8296 97.719 16.527 98.1118C16.2286 98.5058 15.8213 98.6461 15.6049 98.6881C15.6621 98.3718 15.8058 97.8647 16.1715 97.2663C16.1715 97.2663 16.0466 97.3796 15.8858 97.6C15.7253 97.8207 15.5289 98.1487 15.3944 98.5891C15.2962 98.3932 15.1361 97.9737 15.2698 97.5107C15.4027 97.042 15.8684 96.5326 16.8765 96.1133Z",
    fill: "url(#paint63_linear_840_2843)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6797 96.8585C11.166 97.2659 11.5618 97.5003 11.9265 97.5973C12.2907 97.6944 12.5842 97.6781 12.8215 97.6064C13.295 97.4609 13.5494 97.1011 13.6615 96.9114C13.5014 96.8832 13.2869 96.8554 13.02 96.842C12.758 96.8259 12.4538 96.8179 12.094 96.8422C12.094 96.8422 12.2506 96.7786 12.5209 96.7291C12.7949 96.6768 13.1639 96.6491 13.6366 96.6766C13.4689 96.5213 13.1747 96.1928 12.6748 96.0953C12.1832 95.9989 11.5006 96.0959 10.6797 96.8585Z",
    fill: "url(#paint64_linear_840_2843)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7479 94.2266C15.7479 94.7185 15.6582 95.1297 15.5583 95.4417C15.4578 95.7542 15.3061 95.9904 15.1343 96.1638C14.7918 96.5127 14.3635 96.6025 14.1395 96.6184C14.1844 96.4679 14.2558 96.2735 14.3698 96.0494C14.4887 95.8223 14.6604 95.5599 14.8845 95.2849C14.8845 95.2849 14.7453 95.3814 14.5541 95.5805C14.3671 95.7777 14.1097 96.0888 13.9355 96.4979C13.8422 96.3037 13.7732 95.8469 13.9712 95.4028C14.1727 94.9507 14.6782 94.5185 15.7479 94.2266Z",
    fill: "url(#paint65_linear_840_2843)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47656 94.1638C10.3407 95.0958 11.0301 95.2596 11.5083 95.1852C11.9922 95.105 12.2975 94.7788 12.4373 94.6037C12.1355 94.5023 11.6207 94.372 10.8915 94.3289C10.8915 94.3289 11.0558 94.2862 11.3338 94.2711C11.6116 94.2557 12.003 94.2676 12.4514 94.3641C12.3276 94.1787 12.0398 93.8305 11.5504 93.6706C11.0779 93.51 10.4034 93.511 9.47656 94.1638Z",
    fill: "url(#paint66_linear_840_2843)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8537 92.2207C14.7295 93.1938 14.3937 93.7564 13.9972 94.0583C13.6074 94.3613 13.1771 94.3917 12.9569 94.3764C13.0932 94.0861 13.3621 93.6342 13.8695 93.1518C13.8695 93.1518 13.7195 93.2289 13.5074 93.3998C13.2954 93.5711 13.0213 93.8366 12.7784 94.2266C12.7334 94.0123 12.6858 93.5665 12.9337 93.1547C13.195 92.7325 13.768 92.3653 14.8537 92.2207Z",
    fill: "url(#paint67_linear_840_2843)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67969 91.3289C9.04205 91.8496 9.36854 92.1777 9.68873 92.3683C10.016 92.5569 10.304 92.6175 10.552 92.61C11.0474 92.5926 11.3861 92.3114 11.5434 92.1576C11.3961 92.0887 11.195 92.0063 10.9414 91.9237C10.6988 91.8382 10.4025 91.7525 10.05 91.6818C10.05 91.6818 10.2178 91.6612 10.4917 91.6838C10.7717 91.7042 11.1317 91.7746 11.5798 91.9245C11.4632 91.7297 11.262 91.3366 10.805 91.1121C10.3552 90.8909 9.67066 90.8066 8.67969 91.3289Z",
    fill: "url(#paint68_linear_840_2843)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2517 90.1074C14.1224 90.5823 13.934 90.9546 13.7496 91.2314C13.5719 91.5064 13.3643 91.6948 13.1535 91.8175C12.7323 92.065 12.2949 92.0406 12.0742 91.9977C12.1567 91.8641 12.2751 91.6954 12.4441 91.5085C12.6241 91.3187 12.8537 91.1113 13.1429 90.9039C13.1429 90.9039 12.9834 90.9607 12.747 91.1031C12.5168 91.2443 12.1838 91.4786 11.908 91.8285C11.8733 91.6154 11.923 91.157 12.2301 90.7799C12.5422 90.396 13.1426 90.1107 14.2517 90.1074Z",
    fill: "url(#paint69_linear_840_2843)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23438 88.4194C8.83395 89.542 9.44919 89.8808 9.9322 89.9332C10.4201 89.9819 10.8001 89.7466 10.9809 89.614C10.7163 89.4374 10.2537 89.1774 9.56129 88.9461C9.56129 88.9461 9.73112 88.9476 10.0033 89.0054C10.2754 89.0628 10.6499 89.1763 11.0572 89.3862C10.9863 89.175 10.7998 88.7637 10.3695 88.482C9.94554 88.2048 9.30271 88.0306 8.23438 88.4194Z",
    fill: "url(#paint70_linear_840_2843)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9059 87.9369C13.5408 88.8449 13.0624 89.3011 12.6029 89.4892C12.1475 89.6802 11.7243 89.5973 11.5158 89.5251C11.7234 89.2803 12.1013 88.914 12.7171 88.5801C12.7171 88.5801 12.5523 88.6155 12.3028 88.7253C12.0534 88.8356 11.7194 89.0206 11.3828 89.334C11.3955 89.1153 11.4664 88.6723 11.8135 88.3391C12.1662 88.0004 12.8234 87.7931 13.9059 87.9369Z",
    fill: "url(#paint71_linear_840_2843)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 85.4766C8.5823 86.6657 9.18223 87.0796 9.65805 87.1944C10.1404 87.3059 10.5413 87.1222 10.7336 87.0143C10.4867 86.805 10.0399 86.4878 9.40222 86.1694C9.40222 86.1694 9.56982 86.1927 9.82939 86.2852C10.087 86.3771 10.4382 86.5379 10.8302 86.7986C10.7671 86.5803 10.6555 86.1485 10.2755 85.8139C9.89525 85.4844 9.25385 85.2277 8.16406 85.4766Z",
    fill: "url(#paint72_linear_840_2843)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8626 85.7346C13.3517 86.5905 12.8522 86.9802 12.3758 87.1071C11.9043 87.2372 11.489 87.1001 11.2875 87.0016C11.5178 86.786 11.918 86.472 12.5909 86.2201C12.5909 86.2201 12.4223 86.2339 12.1579 86.3106C11.8916 86.3878 11.5308 86.5282 11.1719 86.795C11.1926 86.5801 11.3403 86.1501 11.7379 85.8644C12.1357 85.5736 12.7879 85.4515 13.8626 85.7346Z",
    fill: "url(#paint73_linear_840_2843)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 82.5521C8.76165 83.7903 9.26643 84.274 9.7342 84.4505C10.198 84.6233 10.6194 84.4928 10.8241 84.4105C10.5975 84.1702 10.2348 83.8024 9.62621 83.4014C9.62621 83.4014 9.78965 83.4464 10.0364 83.5719C10.2832 83.697 10.6135 83.9024 10.9489 84.2092C10.9383 83.9874 10.8709 83.543 10.5325 83.161C10.1952 82.7844 9.6112 82.4489 8.48438 82.5521Z",
    fill: "url(#paint74_linear_840_2843)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1175 83.544C13.8157 83.9341 13.5265 84.2107 13.2399 84.3952C12.9583 84.5806 12.7016 84.6767 12.4571 84.7093C11.9726 84.7776 11.5786 84.5881 11.3916 84.4644C11.639 84.2792 12.1158 84.0242 12.798 83.8598C12.798 83.8598 12.6293 83.8517 12.3586 83.8936C12.0878 83.936 11.7148 84.0288 11.3047 84.2447C11.3768 84.0371 11.5662 83.6281 11.9925 83.3959C12.4216 83.1589 13.1024 83.1267 14.1175 83.544Z",
    fill: "url(#paint75_linear_840_2843)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19531 79.6895C9.23133 80.3162 9.38968 80.7744 9.56567 81.0979C9.74462 81.4221 9.95827 81.617 10.1743 81.7336C10.6097 81.9652 11.0463 81.8912 11.2654 81.8378C11.0877 81.5736 10.7585 81.1569 10.2062 80.6788C10.2062 80.6788 10.3626 80.7449 10.5923 80.9022C10.8221 81.059 11.1254 81.3068 11.4224 81.6562C11.4428 81.4355 11.4078 80.9786 11.1426 80.5613C10.8667 80.1463 10.3177 79.7323 9.19531 79.6895Z",
    fill: "url(#paint76_linear_840_2843)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6444 81.4151C14.2772 81.7568 13.9674 81.9963 13.663 82.1426C13.3613 82.2898 13.0817 82.3482 12.8351 82.3486C12.344 82.3523 11.98 82.1135 11.8161 81.9677C12.1011 81.8204 12.5894 81.6256 13.2856 81.5517C13.2856 81.5517 13.1197 81.5215 12.8474 81.528C12.5749 81.5349 12.1958 81.5787 11.7656 81.7403C11.8661 81.5445 12.0811 81.1564 12.5543 80.9881C13.0198 80.8123 13.6846 80.8654 14.6444 81.4151Z",
    fill: "url(#paint77_linear_840_2843)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2732 76.9414C10.2065 78.2046 10.5898 78.8123 10.9839 79.1C11.3848 79.3867 11.8283 79.3712 12.0491 79.3457C11.9051 79.0594 11.6196 78.5973 11.1508 78.0575C11.1508 78.0575 11.2966 78.1434 11.5009 78.3284C11.7034 78.512 11.9679 78.7959 12.2246 79.1847C12.2564 78.9612 12.3156 78.5184 12.0936 78.0637C11.8686 77.6132 11.3751 77.1291 10.2732 76.9414Z",
    fill: "url(#paint78_linear_840_2843)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4414 79.3693C14.6472 79.9626 14.0239 80.1264 13.5338 80.0608C13.0463 79.9998 12.7178 79.7156 12.571 79.5481C12.8703 79.4385 13.3661 79.3039 14.0818 79.3289C14.0818 79.3289 13.9208 79.2769 13.6472 79.2464C13.3715 79.2154 12.9863 79.2075 12.5469 79.3144C12.6548 79.1263 12.9528 78.7844 13.43 78.6735C13.9086 78.5577 14.5572 78.6959 15.4414 79.3693Z",
    fill: "url(#paint79_linear_840_2843)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6888 74.3652C11.4657 75.6121 11.7466 76.2544 12.1088 76.596C12.471 76.9341 12.9096 76.9753 13.1298 76.9779C13.0203 76.6729 12.8209 76.1905 12.413 75.586C12.413 75.586 12.5467 75.6904 12.7266 75.9015C12.9068 76.1121 13.1335 76.4292 13.3265 76.8423C13.401 76.6328 13.5069 76.195 13.3404 75.7118C13.1848 75.2412 12.7638 74.7003 11.6888 74.3652Z",
    fill: "url(#paint80_linear_840_2843)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5072 77.4471C15.6496 77.9361 14.9908 78.0066 14.5228 77.8821C14.0497 77.759 13.7583 77.4324 13.6328 77.246C13.9396 77.1744 14.4718 77.1189 15.1643 77.2292C15.1643 77.2292 15.0118 77.1569 14.7463 77.0917C14.4804 77.027 14.1013 76.9697 13.6411 77.0121C13.7864 76.8476 14.1158 76.5413 14.5976 76.4903C15.0958 76.4434 15.726 76.6683 16.5072 77.4471Z",
    fill: "url(#paint81_linear_840_2843)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4319 71.9941C13.3347 72.295 13.2729 72.5616 13.2395 72.7981C13.2111 73.0387 13.2141 73.2516 13.2349 73.4358C13.2778 73.8051 13.4013 74.0679 13.5565 74.2589C13.8684 74.639 14.302 74.7401 14.5227 74.7734C14.4601 74.4613 14.3077 73.9436 13.9869 73.2953C13.9869 73.2953 14.1051 73.4156 14.2545 73.647C14.4072 73.8805 14.5934 74.2264 14.7357 74.6647C14.7841 74.5643 14.8472 74.4074 14.8845 74.2127C14.9239 74.0198 14.9471 73.796 14.8984 73.5475C14.7999 73.0562 14.4495 72.4624 13.4319 71.9941Z",
    fill: "url(#paint82_linear_840_2843)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8143 75.6788C17.5849 75.7716 17.3697 75.8388 17.1689 75.8847C16.9733 75.9346 16.7952 75.9654 16.628 75.9758C16.2947 75.9976 16.0151 75.9449 15.7878 75.851C15.3318 75.665 15.0896 75.3062 14.9922 75.107C15.312 75.0805 15.8292 75.0815 16.5066 75.2849C16.5066 75.2849 16.3642 75.1928 16.1077 75.0923C15.8541 74.9947 15.4883 74.8906 15.0312 74.8763C15.1121 74.8025 15.2421 74.6993 15.4119 74.6152C15.5839 74.5328 15.8049 74.4772 16.0494 74.4851C16.5441 74.4989 17.1365 74.801 17.8143 75.6788Z",
    fill: "url(#paint83_linear_840_2843)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2981 71.2695C16.6909 71.4495 16.2751 71.6802 15.994 71.9133C15.7123 72.1585 15.5638 72.4132 15.4926 72.6495C15.3526 73.1236 15.5121 73.5357 15.6084 73.7347C15.8323 73.4943 16.1742 73.0988 16.5313 72.4679C16.5313 72.4679 16.4979 72.6341 16.3899 72.8888C16.2824 73.1449 16.1009 73.4842 15.8179 73.8454C16.0387 73.814 16.477 73.7209 16.8343 73.356C17.1865 72.9917 17.4797 72.3865 17.2981 71.2695Z",
    fill: "url(#paint84_linear_840_2843)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9384 107.951C36.6241 107.929 36.3548 107.887 36.1242 107.83C35.892 107.768 35.6945 107.676 35.5321 107.585C35.2063 107.399 35.0105 107.182 34.8935 106.964C34.6618 106.528 34.736 106.092 34.7904 105.877C35.0548 106.056 35.4778 106.409 35.9518 106.948C35.9518 106.948 35.886 106.793 35.7302 106.568C35.5739 106.34 35.3245 106.029 34.9735 105.726C35.0853 105.722 35.2551 105.727 35.45 105.77C35.6424 105.805 35.8572 105.867 36.0673 106.005C36.4819 106.279 36.8955 106.828 36.9384 107.951Z",
    fill: "url(#paint85_linear_840_2843)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2008 102.504C35.0289 102.684 34.8855 102.86 34.7672 103.03C34.6473 103.195 34.5486 103.34 34.4748 103.49C34.3258 103.784 34.2665 104.06 34.2657 104.305C34.2617 104.796 34.5005 105.16 34.6474 105.328C34.7949 105.045 34.9962 104.58 35.0664 103.871C35.0664 103.871 35.0968 104.038 35.0917 104.315C35.0852 104.589 35.0396 104.961 34.8763 105.385C34.9759 105.34 35.1218 105.263 35.2655 105.142C35.4066 105.011 35.5419 104.826 35.6276 104.595C35.8031 104.128 35.75 103.463 35.2008 102.504Z",
    fill: "url(#paint86_linear_840_2843)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6808 106.889C38.4045 106.925 37.8123 106.579 37.5245 106.184C37.2384 105.785 37.2536 105.34 37.2771 105.114C37.5611 105.253 38.0156 105.52 38.5603 106.001C38.5603 106.001 38.4743 105.855 38.2888 105.649C38.1037 105.443 37.8192 105.177 37.4353 104.932C37.6526 104.885 38.0998 104.836 38.5572 105.065C39.01 105.295 39.4954 105.792 39.6808 106.889Z",
    fill: "url(#paint87_linear_840_2843)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M37.251 101.719C36.6445 102.482 36.4958 103.143 36.561 103.633C36.6223 104.121 36.9061 104.449 37.0716 104.591C37.179 104.286 37.3062 103.772 37.2865 103.068C37.2865 103.068 37.3382 103.229 37.368 103.501C37.3974 103.773 37.4046 104.157 37.3024 104.608C37.4844 104.485 37.8307 104.197 37.9444 103.726C38.0628 103.253 37.9262 102.608 37.251 101.719Z",
    fill: "url(#paint88_linear_840_2843)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2532 105.462C41.9438 105.521 41.6727 105.55 41.435 105.554C41.1981 105.56 40.9807 105.518 40.8012 105.474C40.4383 105.379 40.1926 105.22 40.023 105.04C39.6857 104.679 39.6438 104.239 39.6406 104.017C39.9417 104.12 40.4448 104.356 41.0392 104.748C41.0392 104.748 40.9353 104.615 40.7262 104.438C40.5196 104.264 40.1953 104.025 39.7782 103.824C39.8849 103.791 40.0508 103.753 40.2495 103.743C40.4415 103.721 40.6675 103.73 40.9058 103.807C41.3781 103.966 41.92 104.389 42.2532 105.462Z",
    fill: "url(#paint89_linear_840_2843)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1769 100.646C39.0568 100.864 38.9636 101.071 38.8932 101.266C38.8237 101.462 38.7634 101.623 38.7317 101.788C38.6644 102.112 38.6789 102.394 38.7417 102.63C38.8654 103.105 39.191 103.394 39.3767 103.519C39.4446 103.205 39.5208 102.709 39.4009 102C39.4009 102 39.4736 102.153 39.5406 102.422C39.6091 102.695 39.6591 103.061 39.6124 103.514C39.6969 103.445 39.8184 103.333 39.9247 103.177C40.0243 103.01 40.1095 102.801 40.1318 102.554C40.1806 102.059 39.9569 101.43 39.1769 100.646Z",
    fill: "url(#paint90_linear_840_2843)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6436 103.723C43.4186 104.084 42.756 103.901 42.3753 103.594C41.9968 103.284 41.8939 102.848 41.8594 102.625C42.1702 102.686 42.6792 102.828 43.3304 103.152C43.3304 103.152 43.2095 103.033 42.9768 102.882C42.7444 102.731 42.4004 102.547 41.9654 102.409C42.1638 102.308 42.5843 102.147 43.0859 102.25C43.5877 102.361 44.1673 102.696 44.6436 103.723Z",
    fill: "url(#paint91_linear_840_2843)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9662 99.3574C40.5741 100.25 40.6004 100.925 40.7899 101.38C40.9772 101.838 41.334 102.078 41.5319 102.174C41.5572 101.852 41.5478 101.324 41.3475 100.65C41.3475 100.65 41.439 100.792 41.538 101.046C41.6366 101.301 41.7425 101.67 41.7599 102.131C41.9045 101.966 42.1656 101.6 42.1545 101.117C42.1514 100.635 41.8355 100.026 40.9662 99.3574Z",
    fill: "url(#paint92_linear_840_2843)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7466 101.672C45.6224 102.231 44.8998 102.093 44.4845 101.84C44.0651 101.578 43.9113 101.164 43.8516 100.952C44.172 100.976 44.7157 101.071 45.3872 101.293C45.3872 101.293 45.2524 101.191 45.0045 101.074C44.8805 101.015 44.7288 100.952 44.5521 100.895C44.3709 100.833 44.164 100.775 43.9353 100.73C44.1348 100.621 44.5168 100.393 45.0175 100.42C45.516 100.453 46.1493 100.723 46.7466 101.672Z",
    fill: "url(#paint93_linear_840_2843)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5297 97.8184C42.3002 98.7961 42.3716 99.4197 42.6208 99.8486C42.8622 100.275 43.2523 100.471 43.4641 100.544C43.4519 100.226 43.3945 99.7245 43.0923 99.0664C43.0923 99.0664 43.2019 99.1957 43.3355 99.4377C43.4022 99.5588 43.4749 99.7086 43.5411 99.8852C43.6027 100.057 43.657 100.256 43.6915 100.479C43.8293 100.313 44.0267 99.9023 43.9429 99.4148C43.8638 98.9248 43.4866 98.3757 42.5297 97.8184Z",
    fill: "url(#paint94_linear_840_2843)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6062 99.3839C47.5234 100.053 46.8248 100.04 46.3801 99.8424C45.9339 99.6399 45.7229 99.2454 45.6328 99.0399C45.9499 99.0195 46.4797 99.0263 47.194 99.1733C47.194 99.1733 47.0464 99.0894 46.7822 99.0029C46.5182 98.9161 46.1378 98.8265 45.6806 98.8042C45.8475 98.6567 46.2142 98.3938 46.727 98.3656C47.2348 98.3402 47.8776 98.511 48.6062 99.3839Z",
    fill: "url(#paint95_linear_840_2843)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9071 96.1133C43.7661 97.0815 43.954 97.719 44.2566 98.1118C44.555 98.5058 44.9623 98.6461 45.1787 98.6881C45.1215 98.3718 44.9778 97.8647 44.6121 97.2663C44.6121 97.2663 44.7369 97.3796 44.8978 97.6C45.0583 97.8207 45.2547 98.1487 45.3892 98.5891C45.4874 98.3932 45.6475 97.9737 45.5138 97.5107C45.3809 97.042 44.9152 96.5326 43.9071 96.1133Z",
    fill: "url(#paint96_linear_840_2843)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1146 96.8585C49.6283 97.2659 49.2324 97.5003 48.8678 97.5973C48.5035 97.6944 48.2101 97.6781 47.9727 97.6064C47.4993 97.4609 47.2449 97.1011 47.1328 96.9114C47.2929 96.8832 47.5074 96.8554 47.7743 96.842C48.0363 96.8259 48.3405 96.8179 48.7003 96.8422C48.7003 96.8422 48.5437 96.7786 48.2734 96.7291C47.9994 96.6768 47.6303 96.6491 47.1577 96.6766C47.3253 96.5213 47.6196 96.1928 48.1195 96.0953C48.6111 95.9989 49.2937 96.0959 50.1146 96.8585Z",
    fill: "url(#paint97_linear_840_2843)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0391 94.2266C45.0391 94.7185 45.1287 95.1297 45.2286 95.4417C45.3291 95.7542 45.4808 95.9904 45.6527 96.1638C45.9952 96.5127 46.4235 96.6025 46.6475 96.6184C46.6025 96.4679 46.5311 96.2735 46.4171 96.0494C46.2983 95.8223 46.1265 95.5599 45.9024 95.2849C45.9024 95.2849 46.0417 95.3814 46.2329 95.5805C46.4199 95.7777 46.6773 96.0888 46.8514 96.4979C46.9448 96.3037 47.0137 95.8469 46.8158 95.4028C46.6142 94.9507 46.1087 94.5185 45.0391 94.2266Z",
    fill: "url(#paint98_linear_840_2843)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3108 94.1638C50.4466 95.0958 49.7572 95.2596 49.279 95.1852C48.7951 95.105 48.4898 94.7788 48.35 94.6037C48.6518 94.5023 49.1666 94.372 49.8959 94.3289C49.8959 94.3289 49.7315 94.2862 49.4535 94.2711C49.1757 94.2557 48.7843 94.2676 48.3359 94.3641C48.4597 94.1787 48.7475 93.8305 49.2369 93.6706C49.7095 93.51 50.3839 93.511 51.3108 94.1638Z",
    fill: "url(#paint99_linear_840_2843)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9297 92.2207C46.0539 93.1938 46.3897 93.7564 46.7862 94.0583C47.176 94.3613 47.6063 94.3917 47.8265 94.3764C47.6901 94.0861 47.4212 93.6342 46.9139 93.1518C46.9139 93.1518 47.0639 93.2289 47.276 93.3998C47.4879 93.5711 47.7621 93.8366 48.005 94.2266C48.05 94.0123 48.0976 93.5665 47.8497 93.1547C47.5884 92.7325 47.0154 92.3653 45.9297 92.2207Z",
    fill: "url(#paint100_linear_840_2843)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1111 91.3289C51.7487 91.8496 51.4223 92.1777 51.102 92.3683C50.7748 92.5569 50.4868 92.6175 50.2388 92.61C49.7434 92.5926 49.4047 92.3114 49.2474 92.1576C49.3946 92.0887 49.5958 92.0063 49.8494 91.9237C50.092 91.8382 50.3883 91.7525 50.7408 91.6818C50.7408 91.6818 50.573 91.6612 50.2991 91.6838C50.0191 91.7042 49.6591 91.7746 49.2109 91.9245C49.3276 91.7297 49.5288 91.3366 49.9858 91.1121C50.4356 90.8909 51.1201 90.8066 52.1111 91.3289Z",
    fill: "url(#paint101_linear_840_2843)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5234 90.1074C46.6527 90.5823 46.8411 90.9546 47.0255 91.2314C47.2032 91.5064 47.4108 91.6948 47.6217 91.8175C48.0428 92.065 48.4802 92.0406 48.7009 91.9977C48.6184 91.8641 48.5001 91.6954 48.331 91.5085C48.151 91.3187 47.9214 91.1113 47.6322 90.9039C47.6322 90.9039 47.7918 90.9607 48.0282 91.1031C48.2583 91.2443 48.5913 91.4786 48.8671 91.8285C48.9019 91.6154 48.8521 91.157 48.545 90.7799C48.2329 90.396 47.6325 90.1107 46.5234 90.1074Z",
    fill: "url(#paint102_linear_840_2843)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5572 88.4155C51.9577 89.5381 51.3424 89.8769 50.8594 89.9293C50.3715 89.978 49.9915 89.7427 49.8107 89.6101C50.0754 89.4335 50.5379 89.1735 51.2303 88.9422C51.2303 88.9422 51.0605 88.9437 50.7883 89.0015C50.5162 89.0589 50.1417 89.1724 49.7344 89.3823C49.8053 89.1711 49.9918 88.7598 50.4221 88.4781C50.8461 88.2009 51.4889 88.0267 52.5572 88.4155Z",
    fill: "url(#paint103_linear_840_2843)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 87.9369C47.2401 88.8449 47.7185 89.3011 48.178 89.4892C48.6335 89.6802 49.0566 89.5973 49.2651 89.5251C49.0575 89.2803 48.6796 88.914 48.0638 88.5801C48.0638 88.5801 48.2286 88.6155 48.4781 88.7253C48.7275 88.8356 49.0616 89.0206 49.3981 89.334C49.3854 89.1153 49.3146 88.6723 48.9674 88.3391C48.6148 88.0004 47.9575 87.7931 46.875 87.9369Z",
    fill: "url(#paint104_linear_840_2843)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6271 85.4766C52.2089 86.6657 51.6089 87.0796 51.1331 87.1944C50.6508 87.3059 50.2499 87.1222 50.0576 87.0143C50.3045 86.805 50.7513 86.4878 51.389 86.1694C51.389 86.1694 51.2214 86.1927 50.9618 86.2852C50.7042 86.3771 50.3531 86.5379 49.9609 86.7986C50.0241 86.5803 50.1356 86.1485 50.5157 85.8139C50.8959 85.4844 51.5373 85.2277 52.6271 85.4766Z",
    fill: "url(#paint105_linear_840_2843)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9219 85.7346C47.4328 86.5905 47.9322 86.9802 48.4086 87.1071C48.8801 87.2372 49.2954 87.1001 49.4969 87.0016C49.2666 86.786 48.8664 86.472 48.1935 86.2201C48.1935 86.2201 48.3621 86.2339 48.6265 86.3106C48.8928 86.3878 49.2536 86.5282 49.6126 86.795C49.5918 86.5801 49.4441 86.1501 49.0465 85.8644C48.6487 85.5736 47.9965 85.4515 46.9219 85.7346Z",
    fill: "url(#paint106_linear_840_2843)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3005 82.5521C52.0232 83.7903 51.5184 84.274 51.0507 84.4505C50.5868 84.6233 50.1654 84.4928 49.9608 84.4105C50.1873 84.1702 50.5501 83.8024 51.1586 83.4014C51.1586 83.4014 50.9952 83.4464 50.7484 83.5719C50.5016 83.697 50.1713 83.9024 49.8359 84.2092C49.8466 83.9874 49.914 83.543 50.2524 83.161C50.5897 82.7844 51.1736 82.4489 52.3005 82.5521Z",
    fill: "url(#paint107_linear_840_2843)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6719 83.544C46.9737 83.9341 47.2628 84.2107 47.5494 84.3952C47.8311 84.5806 48.0877 84.6767 48.3322 84.7093C48.8167 84.7776 49.2107 84.5881 49.3978 84.4644C49.1504 84.2792 48.6735 84.0242 47.9913 83.8598C47.9913 83.8598 48.1601 83.8517 48.4308 83.8936C48.7016 83.936 49.0745 84.0288 49.4846 84.2447C49.4126 84.0371 49.2231 83.6281 48.7969 83.3959C48.3677 83.1589 47.6869 83.1267 46.6719 83.544Z",
    fill: "url(#paint108_linear_840_2843)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5913 79.6895C51.5553 80.3162 51.397 80.7744 51.221 81.0979C51.042 81.4221 50.8284 81.617 50.6123 81.7336C50.177 81.9652 49.7403 81.8912 49.5212 81.8378C49.699 81.5736 50.0281 81.1569 50.5805 80.6788C50.5805 80.6788 50.424 80.7449 50.1943 80.9022C49.9645 81.059 49.6612 81.3068 49.3642 81.6562C49.3438 81.4355 49.3789 80.9786 49.644 80.5613C49.9199 80.1463 50.4689 79.7323 51.5913 79.6895Z",
    fill: "url(#paint109_linear_840_2843)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1484 81.4151C46.5156 81.7568 46.8255 81.9963 47.1298 82.1426C47.4315 82.2898 47.7111 82.3482 47.9577 82.3486C48.4488 82.3523 48.8128 82.1135 48.9767 81.9677C48.6918 81.8204 48.2034 81.6256 47.5073 81.5517C47.5073 81.5517 47.6731 81.5215 47.9455 81.528C48.2179 81.5349 48.5971 81.5787 49.0272 81.7403C48.9267 81.5445 48.7117 81.1564 48.2386 80.9881C47.773 80.8123 47.1082 80.8654 46.1484 81.4151Z",
    fill: "url(#paint110_linear_840_2843)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5143 76.9414C50.581 78.2046 50.1978 78.8123 49.8036 79.1C49.4027 79.3867 48.9592 79.3712 48.7385 79.3457C48.8824 79.0594 49.1679 78.5973 49.6368 78.0575C49.6368 78.0575 49.4909 78.1434 49.2866 78.3284C49.0841 78.512 48.8196 78.7959 48.563 79.1847C48.5312 78.9612 48.4719 78.5184 48.694 78.0637C48.9189 77.6132 49.4124 77.1291 50.5143 76.9414Z",
    fill: "url(#paint111_linear_840_2843)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3516 79.3693C46.1458 79.9626 46.7691 80.1264 47.2591 80.0608C47.7466 79.9998 48.0752 79.7156 48.2219 79.5481C47.9226 79.4385 47.4269 79.3039 46.7112 79.3289C46.7112 79.3289 46.8722 79.2769 47.1457 79.2464C47.4215 79.2154 47.8066 79.2075 48.2461 79.3144C48.1382 79.1263 47.8401 78.7844 47.363 78.6735C46.8843 78.5577 46.2358 78.6959 45.3516 79.3693Z",
    fill: "url(#paint112_linear_840_2843)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0917 74.3652C49.3147 75.6121 49.0339 76.2544 48.6716 76.596C48.3095 76.9341 47.8708 76.9753 47.6506 76.9779C47.7602 76.6729 47.9596 76.1905 48.3675 75.586C48.3675 75.586 48.2338 75.6904 48.0539 75.9015C47.8737 76.1121 47.647 76.4292 47.454 76.8423C47.3795 76.6328 47.2736 76.195 47.4401 75.7118C47.5957 75.2412 48.0166 74.7003 49.0917 74.3652Z",
    fill: "url(#paint113_linear_840_2843)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2812 77.4471C45.1389 77.9361 45.7977 78.0066 46.2657 77.8821C46.7387 77.759 47.0302 77.4324 47.1556 77.246C46.8489 77.1744 46.3167 77.1189 45.6241 77.2292C45.6241 77.2292 45.7766 77.1569 46.0422 77.0917C46.308 77.027 46.6872 76.9697 47.1474 77.0121C47.002 76.8476 46.6727 76.5413 46.1908 76.4903C45.6927 76.4434 45.0624 76.6683 44.2812 77.4471Z",
    fill: "url(#paint114_linear_840_2843)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3377 71.9941C47.4349 72.295 47.4967 72.5616 47.5302 72.7981C47.5586 73.0387 47.5555 73.2516 47.5347 73.4358C47.4919 73.8051 47.3683 74.0679 47.2131 74.2589C46.9013 74.639 46.4676 74.7401 46.247 74.7734C46.3095 74.4613 46.4619 73.9436 46.7828 73.2953C46.7828 73.2953 46.6645 73.4156 46.5152 73.647C46.3624 73.8805 46.1762 74.2264 46.034 74.6647C45.9856 74.5643 45.9224 74.4074 45.8852 74.2127C45.8457 74.0198 45.8226 73.796 45.8713 73.5475C45.9697 73.0562 46.3201 72.4624 47.3377 71.9941Z",
    fill: "url(#paint115_linear_840_2843)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9766 75.6788C43.2059 75.7716 43.4211 75.8388 43.6219 75.8847C43.8176 75.9346 43.9956 75.9654 44.1628 75.9758C44.4961 75.9976 44.7757 75.9449 45.003 75.851C45.4591 75.665 45.7012 75.3062 45.7986 75.107C45.4789 75.0805 44.9616 75.0815 44.2842 75.2849C44.2842 75.2849 44.4267 75.1928 44.6831 75.0923C44.9367 74.9947 45.3025 74.8906 45.7596 74.8763C45.6787 74.8025 45.5487 74.6993 45.3789 74.6152C45.2069 74.5328 44.9859 74.4772 44.7414 74.4851C44.2467 74.4989 43.6544 74.801 42.9766 75.6788Z",
    fill: "url(#paint116_linear_840_2843)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M43.493 71.2695C44.1002 71.4495 44.5159 71.6802 44.797 71.9133C45.0788 72.1585 45.2272 72.4132 45.2984 72.6495C45.4384 73.1236 45.2789 73.5357 45.1827 73.7347C44.9587 73.4943 44.6168 73.0988 44.2597 72.4679C44.2597 72.4679 44.2931 72.6341 44.4011 72.8888C44.5086 73.1449 44.6902 73.4842 44.9731 73.8454C44.7523 73.814 44.314 73.7209 43.9567 73.356C43.6045 72.9917 43.3113 72.3865 43.493 71.2695Z",
    fill: "url(#paint117_linear_840_2843)"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M37.126 107.951C36.8116 107.929 36.5423 107.887 36.3117 107.83C36.0795 107.768 35.8819 107.676 35.7196 107.585C35.3938 107.399 35.198 107.182 35.081 106.964C34.8493 106.528 34.9234 106.092 34.978 105.877C35.2423 106.056 35.6653 106.409 36.1393 106.948C36.1393 106.948 36.0736 106.793 35.9177 106.568C35.7614 106.34 35.512 106.029 35.161 105.726C35.2728 105.722 35.4426 105.727 35.6375 105.77C35.8299 105.805 36.0447 105.867 36.2548 106.005C36.6694 106.279 37.083 106.828 37.126 107.951Z",
    fill: "url(#paint118_linear_840_2843)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4117 102.504C35.2398 102.684 35.0965 102.86 34.9782 103.03C34.8583 103.195 34.7595 103.34 34.6857 103.49C34.5368 103.784 34.4775 104.06 34.4766 104.305C34.4726 104.796 34.7115 105.16 34.8584 105.328C35.0059 105.045 35.2072 104.58 35.2773 103.871C35.2773 103.871 35.3078 104.038 35.3027 104.315C35.2961 104.589 35.2505 104.961 35.0872 105.385C35.1868 105.34 35.3328 105.263 35.4764 105.142C35.6175 105.011 35.7529 104.826 35.8385 104.595C36.0141 104.128 35.9609 103.463 35.4117 102.504Z",
    fill: "url(#paint119_linear_840_2843)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8995 106.889C38.6232 106.925 38.0311 106.579 37.7432 106.184C37.4571 105.785 37.4724 105.34 37.4959 105.114C37.7799 105.253 38.2344 105.52 38.7791 106.001C38.7791 106.001 38.6931 105.855 38.5075 105.649C38.3224 105.443 38.038 105.177 37.6541 104.932C37.8714 104.885 38.3186 104.836 38.776 105.065C39.2287 105.295 39.7141 105.792 39.8995 106.889Z",
    fill: "url(#paint120_linear_840_2843)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4697 101.719C36.8633 102.482 36.7146 103.143 36.7798 103.633C36.8411 104.121 37.1249 104.449 37.2903 104.591C37.3977 104.286 37.5249 103.772 37.5052 103.068C37.5052 103.068 37.557 103.229 37.5868 103.501C37.6162 103.773 37.6234 104.157 37.5212 104.608C37.7032 104.485 38.0494 104.197 38.1631 103.726C38.2815 103.253 38.145 102.608 37.4697 101.719Z",
    fill: "url(#paint121_linear_840_2843)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4562 105.462C42.1469 105.521 41.8758 105.55 41.6381 105.554C41.4013 105.56 41.1838 105.518 41.0043 105.474C40.6414 105.379 40.3958 105.22 40.2261 105.04C39.8888 104.679 39.8469 104.239 39.8438 104.017C40.1448 104.12 40.648 104.356 41.2423 104.748C41.2423 104.748 41.1384 104.615 40.9293 104.438C40.7227 104.264 40.3984 104.025 39.9813 103.824C40.088 103.791 40.2539 103.753 40.4526 103.743C40.6446 103.721 40.8707 103.73 41.109 103.807C41.5812 103.966 42.1232 104.389 42.4562 105.462Z",
    fill: "url(#paint122_linear_840_2843)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M39.38 100.646C39.26 100.864 39.1667 101.071 39.0963 101.266C39.0268 101.462 38.9665 101.623 38.9349 101.788C38.8675 102.112 38.882 102.394 38.9449 102.63C39.0685 103.105 39.3941 103.394 39.5798 103.519C39.6477 103.205 39.7239 102.709 39.604 102C39.604 102 39.6767 102.153 39.7437 102.422C39.8123 102.695 39.8623 103.061 39.8156 103.514C39.9 103.445 40.0215 103.333 40.1278 103.177C40.2274 103.01 40.3126 102.801 40.3349 102.554C40.3837 102.059 40.1601 101.43 39.38 100.646Z",
    fill: "url(#paint123_linear_840_2843)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8389 103.723C43.6139 104.084 42.9513 103.901 42.5707 103.594C42.1921 103.284 42.0892 102.848 42.0547 102.625C42.3655 102.686 42.8745 102.828 43.5257 103.152C43.5257 103.152 43.4048 103.033 43.1721 102.882C42.9397 102.731 42.5958 102.547 42.1608 102.409C42.3592 102.308 42.7796 102.147 43.2812 102.25C43.783 102.361 44.3627 102.696 44.8389 103.723Z",
    fill: "url(#paint124_linear_840_2843)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1537 99.3574C40.7616 100.25 40.7879 100.925 40.9774 101.38C41.1647 101.838 41.5215 102.078 41.7194 102.174C41.7447 101.852 41.7353 101.324 41.535 100.65C41.535 100.65 41.6265 100.792 41.7255 101.046C41.8241 101.301 41.93 101.67 41.9475 102.131C42.092 101.966 42.3531 101.6 42.342 101.117C42.3389 100.635 42.023 100.026 41.1537 99.3574Z",
    fill: "url(#paint125_linear_840_2843)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9497 101.672C45.8255 102.231 45.1029 102.093 44.6876 101.84C44.2682 101.578 44.1145 101.164 44.0547 100.952C44.3752 100.976 44.9188 101.071 45.5904 101.293C45.5904 101.293 45.4556 101.191 45.2076 101.074C45.0836 101.015 44.9319 100.952 44.7552 100.895C44.574 100.833 44.3671 100.775 44.1384 100.73C44.338 100.621 44.7199 100.393 45.2206 100.42C45.7192 100.453 46.3525 100.723 46.9497 101.672Z",
    fill: "url(#paint126_linear_840_2843)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7406 97.8184C42.5111 98.7961 42.5825 99.4197 42.8317 99.8486C43.0732 100.275 43.4632 100.471 43.6751 100.544C43.6628 100.226 43.6055 99.7245 43.3032 99.0664C43.3032 99.0664 43.4129 99.1957 43.5465 99.4377C43.6131 99.5588 43.6858 99.7086 43.752 99.8852C43.8136 100.057 43.868 100.256 43.9024 100.479C44.0402 100.313 44.2377 99.9023 44.1539 99.4148C44.0747 98.9248 43.6976 98.3757 42.7406 97.8184Z",
    fill: "url(#paint127_linear_840_2843)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8015 99.3839C47.7187 100.053 47.0201 100.04 46.5754 99.8424C46.1293 99.6399 45.9182 99.2454 45.8281 99.0399C46.1452 99.0195 46.6751 99.0263 47.3893 99.1733C47.3893 99.1733 47.2417 99.0894 46.9775 99.0029C46.7135 98.9161 46.3331 98.8265 45.8759 98.8042C46.0428 98.6567 46.4095 98.3938 46.9223 98.3656C47.4301 98.3402 48.0729 98.511 48.8015 99.3839Z",
    fill: "url(#paint128_linear_840_2843)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1102 96.1133C43.9692 97.0815 44.1571 97.719 44.4598 98.1118C44.7582 98.5058 45.1655 98.6461 45.3818 98.6881C45.3246 98.3718 45.1809 97.8647 44.8152 97.2663C44.8152 97.2663 44.9401 97.3796 45.1009 97.6C45.2614 97.8207 45.4578 98.1487 45.5923 98.5891C45.6905 98.3932 45.8506 97.9737 45.7169 97.5107C45.584 97.042 45.1183 96.5326 44.1102 96.1133Z",
    fill: "url(#paint129_linear_840_2843)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3255 96.8585C49.8392 97.2659 49.4434 97.5003 49.0787 97.5973C48.7145 97.6944 48.421 97.6781 48.1837 97.6064C47.7102 97.4609 47.4558 97.1011 47.3438 96.9114C47.5038 96.8832 47.7183 96.8554 47.9852 96.842C48.2472 96.8259 48.5514 96.8179 48.9112 96.8422C48.9112 96.8422 48.7546 96.7786 48.4844 96.7291C48.2103 96.6768 47.8413 96.6491 47.3686 96.6766C47.5363 96.5213 47.8305 96.1928 48.3304 96.0953C48.822 95.9989 49.5046 96.0959 50.3255 96.8585Z",
    fill: "url(#paint130_linear_840_2843)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 94.2266C45.25 94.7185 45.3397 95.1297 45.4396 95.4417C45.54 95.7542 45.6918 95.9904 45.8636 96.1638C46.2061 96.5127 46.6344 96.6025 46.8584 96.6184C46.8135 96.4679 46.742 96.2735 46.6281 96.0494C46.5092 95.8223 46.3374 95.5599 46.1134 95.2849C46.1134 95.2849 46.2526 95.3814 46.4438 95.5805C46.6308 95.7777 46.8882 96.0888 47.0624 96.4979C47.1557 96.3037 47.2247 95.8469 47.0267 95.4028C46.8251 94.9507 46.3197 94.5185 45.25 94.2266Z",
    fill: "url(#paint131_linear_840_2843)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5061 94.1638C50.6419 95.0958 49.9525 95.2596 49.4744 95.1852C48.9905 95.105 48.6851 94.7788 48.5453 94.6037C48.8471 94.5023 49.3619 94.372 50.0912 94.3289C50.0912 94.3289 49.9268 94.2862 49.6488 94.2711C49.371 94.2557 48.9796 94.2676 48.5312 94.3641C48.6551 94.1787 48.9429 93.8305 49.4322 93.6706C49.9048 93.51 50.5792 93.511 51.5061 94.1638Z",
    fill: "url(#paint132_linear_840_2843)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1406 92.2207C46.2648 93.1938 46.6006 93.7564 46.9971 94.0583C47.3869 94.3613 47.8172 94.3917 48.0375 94.3764C47.9011 94.0861 47.6322 93.6342 47.1249 93.1518C47.1249 93.1518 47.2748 93.2289 47.4869 93.3998C47.6989 93.5711 47.9731 93.8366 48.216 94.2266C48.261 94.0123 48.3086 93.5665 48.0606 93.1547C47.7993 92.7325 47.2263 92.3653 46.1406 92.2207Z",
    fill: "url(#paint133_linear_840_2843)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3142 91.3289C51.9518 91.8496 51.6254 92.1777 51.3052 92.3683C50.9779 92.5569 50.6899 92.6175 50.4419 92.61C49.9465 92.5926 49.6078 92.3114 49.4505 92.1576C49.5978 92.0887 49.7989 92.0063 50.0525 91.9237C50.2951 91.8382 50.5914 91.7525 50.9439 91.6818C50.9439 91.6818 50.7761 91.6612 50.5022 91.6838C50.2222 91.7042 49.8622 91.7746 49.4141 91.9245C49.5307 91.7297 49.7319 91.3366 50.1889 91.1121C50.6387 90.8909 51.3233 90.8066 52.3142 91.3289Z",
    fill: "url(#paint134_linear_840_2843)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7422 90.1074C46.8715 90.5823 47.0599 90.9546 47.2443 91.2314C47.4219 91.5064 47.6295 91.6948 47.8404 91.8175C48.2615 92.065 48.6989 92.0406 48.9197 91.9977C48.8372 91.8641 48.7188 91.6954 48.5498 91.5085C48.3698 91.3187 48.1402 91.1113 47.851 90.9039C47.851 90.9039 48.0105 90.9607 48.2469 91.1031C48.477 91.2443 48.8101 91.4786 49.0859 91.8285C49.1206 91.6154 49.0708 91.157 48.7638 90.7799C48.4517 90.396 47.8512 90.1107 46.7422 90.1074Z",
    fill: "url(#paint135_linear_840_2843)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M52.776 88.4194C52.1764 89.542 51.5612 89.8808 51.0781 89.9332C50.5903 89.9819 50.2102 89.7466 50.0294 89.614C50.2941 89.4374 50.7567 89.1774 51.4491 88.9461C51.4491 88.9461 51.2792 88.9476 51.0071 89.0054C50.735 89.0628 50.3605 89.1763 49.9531 89.3862C50.024 89.175 50.2105 88.7637 50.6408 88.482C51.0648 88.2048 51.7077 88.0306 52.776 88.4194Z",
    fill: "url(#paint136_linear_840_2843)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0703 87.9369C47.4354 88.8449 47.9138 89.3011 48.3733 89.4892C48.8288 89.6802 49.2519 89.5973 49.4604 89.5251C49.2528 89.2803 48.875 88.914 48.2591 88.5801C48.2591 88.5801 48.4239 88.6155 48.6734 88.7253C48.9228 88.8356 49.2569 89.0206 49.5934 89.334C49.5807 89.1153 49.5099 88.6723 49.1627 88.3391C48.8101 88.0004 48.1528 87.7931 47.0703 87.9369Z",
    fill: "url(#paint137_linear_840_2843)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8303 85.4766C52.412 86.6657 51.8121 87.0796 51.3363 87.1944C50.8539 87.3059 50.453 87.1222 50.2607 87.0143C50.5076 86.805 50.9545 86.4878 51.5921 86.1694C51.5921 86.1694 51.4245 86.1927 51.1649 86.2852C50.9073 86.3771 50.5562 86.5379 50.1641 86.7986C50.2272 86.5803 50.3388 86.1485 50.7189 85.8139C51.0991 85.4844 51.7405 85.2277 52.8303 85.4766Z",
    fill: "url(#paint138_linear_840_2843)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1172 85.7346C47.6281 86.5905 48.1276 86.9802 48.6039 87.1071C49.0754 87.2372 49.4907 87.1001 49.6922 87.0016C49.462 86.786 49.0617 86.472 48.3888 86.2201C48.3888 86.2201 48.5575 86.2339 48.8219 86.3106C49.0881 86.3878 49.4489 86.5282 49.8079 86.795C49.7871 86.5801 49.6394 86.1501 49.2419 85.8644C48.844 85.5736 48.1919 85.4515 47.1172 85.7346Z",
    fill: "url(#paint139_linear_840_2843)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5114 82.5521C52.2342 83.7903 51.7294 84.274 51.2616 84.4505C50.7978 84.6233 50.3764 84.4928 50.1717 84.4105C50.3983 84.1702 50.761 83.8024 51.3696 83.4014C51.3696 83.4014 51.2062 83.4464 50.9594 83.5719C50.7126 83.697 50.3823 83.9024 50.0469 84.2092C50.0575 83.9874 50.1249 83.543 50.4633 83.161C50.8006 82.7844 51.3846 82.4489 52.5114 82.5521Z",
    fill: "url(#paint140_linear_840_2843)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 83.544C47.1768 83.9341 47.4659 84.2107 47.7525 84.3952C48.0342 84.5806 48.2908 84.6767 48.5354 84.7093C49.0198 84.7776 49.4138 84.5881 49.6009 84.4644C49.3535 84.2792 48.8767 84.0242 48.1944 83.8598C48.1944 83.8598 48.3632 83.8517 48.6339 83.8936C48.9047 83.936 49.2776 84.0288 49.6877 84.2447C49.6157 84.0371 49.4262 83.6281 49 83.3959C48.5708 83.1589 47.8901 83.1267 46.875 83.544Z",
    fill: "url(#paint141_linear_840_2843)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8023 79.6895C51.7662 80.3162 51.6079 80.7744 51.4319 81.0979C51.253 81.4221 51.0393 81.617 50.8232 81.7336C50.3879 81.9652 49.9512 81.8912 49.7322 81.8378C49.9099 81.5736 50.239 81.1569 50.7914 80.6788C50.7914 80.6788 50.6349 80.7449 50.4052 80.9022C50.1754 81.059 49.8722 81.3068 49.5751 81.6562C49.5548 81.4355 49.5898 80.9786 49.855 80.5613C50.1309 80.1463 50.6799 79.7323 51.8023 79.6895Z",
    fill: "url(#paint142_linear_840_2843)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3516 81.4151C46.7187 81.7568 47.0286 81.9963 47.3329 82.1426C47.6346 82.2898 47.9143 82.3482 48.1608 82.3486C48.6519 82.3523 49.0159 82.1135 49.1798 81.9677C48.8949 81.8204 48.4065 81.6256 47.7104 81.5517C47.7104 81.5517 47.8762 81.5215 48.1486 81.528C48.421 81.5349 48.8001 81.5787 49.2303 81.7403C49.1298 81.5445 48.9148 81.1564 48.4417 80.9881C47.9761 80.8123 47.3113 80.8654 46.3516 81.4151Z",
    fill: "url(#paint143_linear_840_2843)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7252 76.9414C50.7919 78.2046 50.4087 78.8123 50.0146 79.1C49.6137 79.3867 49.1701 79.3712 48.9494 79.3457C49.0933 79.0594 49.3788 78.5973 49.8477 78.0575C49.8477 78.0575 49.7019 78.1434 49.4975 78.3284C49.2951 78.512 49.0306 78.7959 48.7739 79.1847C48.7421 78.9612 48.6829 78.5184 48.9049 78.0637C49.1298 77.6132 49.6233 77.1291 50.7252 76.9414Z",
    fill: "url(#paint144_linear_840_2843)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5547 79.3693C46.3489 79.9626 46.9722 80.1264 47.4623 80.0608C47.9498 79.9998 48.2783 79.7156 48.4251 79.5481C48.1257 79.4385 47.63 79.3039 46.9143 79.3289C46.9143 79.3289 47.0753 79.2769 47.3488 79.2464C47.6246 79.2154 48.0097 79.2075 48.4492 79.3144C48.3413 79.1263 48.0432 78.7844 47.5661 78.6735C47.0874 78.5577 46.4389 78.6959 45.5547 79.3693Z",
    fill: "url(#paint145_linear_840_2843)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3104 74.3652C49.5335 75.6121 49.2526 76.2544 48.8904 76.596C48.5282 76.9341 48.0896 76.9753 47.8694 76.9779C47.9789 76.6729 48.1783 76.1905 48.5862 75.586C48.5862 75.586 48.4526 75.6904 48.2726 75.9015C48.0924 76.1121 47.8657 76.4292 47.6727 76.8423C47.5982 76.6328 47.4924 76.195 47.6588 75.7118C47.8144 75.2412 48.2354 74.7003 49.3104 74.3652Z",
    fill: "url(#paint146_linear_840_2843)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4922 77.4471C45.3498 77.9361 46.0086 78.0066 46.4767 77.8821C46.9496 77.759 47.2411 77.4324 47.3666 77.246C47.0598 77.1744 46.5276 77.1189 45.8351 77.2292C45.8351 77.2292 45.9875 77.1569 46.2531 77.0917C46.5189 77.027 46.8981 76.9697 47.3583 77.0121C47.213 76.8476 46.8836 76.5413 46.4018 76.4903C45.9036 76.4434 45.2734 76.6683 44.4922 77.4471Z",
    fill: "url(#paint147_linear_840_2843)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5565 71.9941C47.6537 72.295 47.7155 72.5616 47.7489 72.7981C47.7773 73.0387 47.7743 73.2516 47.7535 73.4358C47.7106 73.8051 47.5871 74.0679 47.4319 74.2589C47.12 74.639 46.6864 74.7401 46.4657 74.7734C46.5283 74.4613 46.6807 73.9436 47.0015 73.2953C47.0015 73.2953 46.8833 73.4156 46.7339 73.647C46.5812 73.8805 46.395 74.2264 46.2527 74.6647C46.2043 74.5643 46.1412 74.4074 46.1039 74.2127C46.0644 74.0198 46.0413 73.796 46.09 73.5475C46.1885 73.0562 46.5389 72.4624 47.5565 71.9941Z",
    fill: "url(#paint148_linear_840_2843)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1875 75.6788C43.4168 75.7716 43.6321 75.8388 43.8329 75.8847C44.0285 75.9346 44.2065 75.9654 44.3737 75.9758C44.7071 75.9976 44.9866 75.9449 45.2139 75.851C45.67 75.665 45.9122 75.3062 46.0096 75.107C45.6898 75.0805 45.1725 75.0815 44.4951 75.2849C44.4951 75.2849 44.6376 75.1928 44.8941 75.0923C45.1477 74.9947 45.5135 74.8906 45.9705 74.8763C45.8897 74.8025 45.7597 74.6993 45.5898 74.6152C45.4178 74.5328 45.1969 74.4772 44.9523 74.4851C44.4577 74.4989 43.8653 74.801 43.1875 75.6788Z",
    fill: "url(#paint149_linear_840_2843)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6961 71.2695C44.3033 71.4495 44.719 71.6802 45.0002 71.9133C45.2819 72.1585 45.4304 72.4132 45.5015 72.6495C45.6415 73.1236 45.482 73.5357 45.3858 73.7347C45.1618 73.4943 44.82 73.0988 44.4628 72.4679C44.4628 72.4679 44.4963 72.6341 44.6042 72.8888C44.7118 73.1449 44.8933 73.4842 45.1762 73.8454C44.9554 73.814 44.5172 73.7209 44.1599 73.356C43.8077 72.9917 43.5144 72.3865 43.6961 71.2695Z",
    fill: "url(#paint150_linear_840_2843)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6985 73.9395C15.6985 73.9395 15.5929 74.0768 15.3951 74.3343C15.1934 74.5891 14.9184 74.9778 14.5822 75.4805C14.2464 75.9839 13.8693 76.6155 13.4818 77.3627C13.1033 78.1145 12.7192 78.9842 12.3796 79.9613C12.0413 80.9385 11.7546 82.0255 11.566 83.1943C11.3769 84.3624 11.2876 85.6127 11.317 86.9009C11.3457 88.1963 11.5028 89.5177 11.8058 90.8402C12.1077 92.1595 12.5544 93.4674 13.1348 94.7132C13.7092 95.9615 14.4132 97.1516 15.2284 98.2326C16.0406 99.3157 16.9528 100.296 17.9186 101.151C19.8504 102.865 21.9796 104.072 23.9122 104.806C24.8816 105.166 25.7929 105.436 26.6138 105.623C27.0244 105.714 27.4126 105.784 27.7711 105.849C28.1321 105.898 28.4632 105.951 28.7638 105.984C29.0653 106.011 29.3344 106.036 29.5686 106.057C29.803 106.077 30.0033 106.078 30.1653 106.087L30.1649 106.104C30.0026 106.1 29.8019 106.105 29.5666 106.094C29.3313 106.079 29.0609 106.062 28.758 106.044C28.4557 106.018 28.1225 105.973 27.7585 105.933C27.397 105.877 27.0052 105.816 26.59 105.735C25.7596 105.569 24.8343 105.32 23.8517 104.968C21.8951 104.252 19.709 103.082 17.7423 101.351C16.7591 100.489 15.8289 99.4998 14.9992 98.405C14.1669 97.3121 13.445 96.108 12.8564 94.8423C12.2732 93.5738 11.8263 92.2437 11.5268 90.9034C11.2263 89.5662 11.0729 88.2083 11.051 86.9076C10.9958 84.2878 11.504 81.8613 12.2172 79.9039C12.5713 78.9219 12.9812 78.0556 13.3811 77.3097C13.7895 76.5679 14.1837 75.9436 14.533 75.4471C14.8811 74.9499 15.1735 74.5723 15.3821 74.324C15.5884 74.0732 15.6985 73.9395 15.6985 73.9395Z",
    fill: "url(#paint151_linear_840_2843)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5266 73.9395C15.5266 73.9395 15.4211 74.0768 15.2232 74.3343C15.0216 74.5891 14.7465 74.9778 14.4103 75.4805C14.0745 75.9839 13.6974 76.6155 13.3099 77.3627C12.9314 78.1145 12.5473 78.9842 12.2077 79.9613C11.8694 80.9385 11.5827 82.0255 11.3941 83.1943C11.205 84.3624 11.1157 85.6127 11.1451 86.9009C11.1738 88.1963 11.3309 89.5177 11.634 90.8402C11.9358 92.1595 12.3825 93.4674 12.9629 94.7132C13.5373 95.9615 14.2413 97.1516 15.0565 98.2326C15.8687 99.3157 16.781 100.296 17.7467 101.151C19.6785 102.865 21.8078 104.072 23.7404 104.806C24.7097 105.166 25.6211 105.436 26.4419 105.623C26.8525 105.714 27.2407 105.784 27.5992 105.849C27.9603 105.898 28.2913 105.951 28.592 105.984C28.8934 106.011 29.1626 106.036 29.3967 106.057C29.6311 106.077 29.8314 106.078 29.9934 106.087C30.3179 106.101 30.4909 106.108 30.4909 106.108C30.4909 106.108 30.3177 106.107 29.993 106.104C29.8307 106.1 29.63 106.105 29.3947 106.094C29.1594 106.079 28.889 106.062 28.5862 106.044C28.2838 106.018 27.9506 105.973 27.5866 105.933C27.2252 105.877 26.8333 105.816 26.4181 105.735C25.5878 105.569 24.6624 105.32 23.6799 104.968C21.7233 104.252 19.5371 103.082 17.5705 101.351C16.5872 100.489 15.657 99.4998 14.8273 98.405C13.995 97.3121 13.2731 96.108 12.6845 94.8423C12.1013 93.5738 11.6544 92.2437 11.3549 90.9034C11.0545 89.5662 10.901 88.2083 10.8791 86.9076C10.8239 84.2878 11.3321 81.8613 12.0453 79.9039C12.3994 78.9219 12.8093 78.0556 13.2093 77.3097C13.6176 76.5679 14.0118 75.9436 14.3611 75.4471C14.7092 74.9499 15.0017 74.5723 15.2103 74.324C15.4166 74.0732 15.5266 73.9395 15.5266 73.9395Z",
    fill: "url(#paint152_linear_840_2843)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M45.295 73.9395C45.295 73.9395 45.4005 74.0768 45.5983 74.3343C45.8 74.5891 46.0751 74.9778 46.4112 75.4805C46.747 75.9839 47.1241 76.6155 47.5117 77.3627C47.8902 78.1145 48.2742 78.9842 48.6138 79.9613C48.9521 80.9385 49.2389 82.0255 49.4274 83.1943C49.6165 84.3624 49.7058 85.6127 49.6764 86.9009C49.6478 88.1963 49.4906 89.5177 49.1876 90.8402C48.8857 92.1595 48.439 93.4674 47.8586 94.7132C47.2842 95.9615 46.5802 97.1516 45.7651 98.2326C44.9528 99.3157 44.0406 100.296 43.0749 101.151C41.1431 102.865 39.0138 104.072 37.0812 104.806C36.1119 105.166 35.2005 105.436 34.3796 105.623C33.969 105.714 33.5809 105.784 33.2223 105.849C32.8613 105.898 32.5303 105.951 32.2296 105.984C31.9281 106.011 31.659 106.036 31.4248 106.057C31.1904 106.077 30.9901 106.078 30.8281 106.087L30.8285 106.104C30.9909 106.1 31.1916 106.105 31.4269 106.094C31.6621 106.079 31.9325 106.062 32.2354 106.044C32.5377 106.018 32.871 105.973 33.2349 105.933C33.5964 105.877 33.9883 105.816 34.4035 105.735C35.2338 105.569 36.1591 105.32 37.1417 104.968C39.0983 104.252 41.2844 103.082 43.2511 101.351C44.2344 100.489 45.1645 99.4998 45.9942 98.405C46.8265 97.3121 47.5484 96.108 48.1371 94.8423C48.7203 93.5738 49.1671 92.2437 49.4667 90.9034C49.7671 89.5662 49.9206 88.2083 49.9425 86.9076C49.9977 84.2878 49.4894 81.8613 48.7762 79.9039C48.4221 78.9219 48.0122 78.0556 47.6123 77.3097C47.2039 76.5679 46.8097 75.9436 46.4605 75.4471C46.1123 74.9499 45.8199 74.5723 45.6113 74.324C45.405 74.0732 45.295 73.9395 45.295 73.9395Z",
    fill: "url(#paint153_linear_840_2843)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4565 73.9395C45.4565 73.9395 45.562 74.0768 45.7599 74.3343C45.9615 74.5891 46.2366 74.9778 46.5728 75.4805C46.9086 75.9839 47.2857 76.6155 47.6732 77.3627C48.0518 78.1145 48.4358 78.9842 48.7754 79.9613C49.1136 80.9385 49.4004 82.0255 49.589 83.1943C49.7781 84.3624 49.8674 85.6127 49.838 86.9009C49.8093 88.1963 49.6522 89.5177 49.3491 90.8402C49.0473 92.1595 48.6005 93.4674 48.0202 94.7132C47.4458 95.9615 46.7418 97.1516 45.9266 98.2326C45.1144 99.3157 44.2021 100.296 43.2364 101.151C41.3046 102.865 39.1753 104.072 37.2427 104.806C36.2734 105.166 35.362 105.436 34.5412 105.623C34.1306 105.714 33.7424 105.784 33.3839 105.849C33.0228 105.898 32.6918 105.951 32.3911 105.984C32.0897 106.011 31.8205 106.036 31.5864 106.057C31.352 106.077 31.1517 106.078 30.9897 106.087C30.6652 106.101 30.4922 106.108 30.4922 106.108C30.4922 106.108 30.6654 106.107 30.9901 106.104C31.1524 106.1 31.3531 106.105 31.5884 106.094C31.8237 106.079 32.0941 106.062 32.3969 106.044C32.6993 106.018 33.0325 105.973 33.3965 105.933C33.7579 105.877 34.1498 105.816 34.565 105.735C35.3953 105.569 36.3207 105.32 37.3032 104.968C39.2598 104.252 41.446 103.082 43.4126 101.351C44.3959 100.489 45.3261 99.4998 46.1558 98.405C46.9881 97.3121 47.71 96.108 48.2986 94.8423C48.8818 93.5738 49.3287 92.2437 49.6283 90.9034C49.9286 89.5662 50.0821 88.2083 50.104 86.9076C50.1592 84.2878 49.651 81.8613 48.9378 79.9039C48.5837 78.9219 48.1738 78.0556 47.7739 77.3097C47.3655 76.5679 46.9713 75.9436 46.622 75.4471C46.2739 74.9499 45.9814 74.5723 45.7728 74.324C45.5665 74.0732 45.4565 73.9395 45.4565 73.9395Z",
    fill: "url(#paint154_linear_840_2843)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 76.7561C28.7113 76.7561 29.5479 75.3592 30.2966 73.7578H33.7917V98.1865H28.6086V80.0743H24.9688V76.7561Z",
    fill: "url(#paint155_linear_840_2843)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 76.7561C28.603 76.7561 29.4154 75.3592 30.1424 73.7578H33.3064V97.6085H28.603V79.4137H24.9688V76.7561Z",
    fill: "url(#paint156_linear_840_2843)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_840_2843",
    x1: 4.71875,
    y1: 29.013,
    x2: 28.1549,
    y2: 29.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_840_2843",
    x1: 9.40625,
    y1: 29.013,
    x2: 32.8424,
    y2: 29.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_840_2843",
    x1: 14.0938,
    y1: 29.013,
    x2: 37.5299,
    y2: 29.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C56A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B388F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_840_2843",
    x1: 21.1228,
    y1: 39.3444,
    x2: 21.1228,
    y2: 58.3686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41009,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82143,
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_840_2843",
    x1: 24.4386,
    y1: 48.3622,
    x2: 36.3136,
    y2: 69.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44388,
    stopColor: "#E0BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#815020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_840_2843",
    x1: 24.0608,
    y1: 47.4005,
    x2: 36.6916,
    y2: 69.4574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37245,
    stopColor: "#FDE66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FDE558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_840_2843",
    x1: 26.0453,
    y1: 50.8574,
    x2: 34.4748,
    y2: 65.5777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37245,
    stopColor: "#FFED9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FDEC88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_840_2843",
    x1: 27.1692,
    y1: 52.1807,
    x2: 33.5856,
    y2: 63.3854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37245,
    stopColor: "#FFED9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FDEC88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_840_2843",
    x1: 14.1985,
    y1: 62.954,
    x2: 48.1891,
    y2: 112.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44388,
    stopColor: "#E0BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#815020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_840_2843",
    x1: 16.9064,
    y1: 50.4461,
    x2: 34.3251,
    y2: 96.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37245,
    stopColor: "#FDE66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FDE558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_840_2843",
    x1: 10.6298,
    y1: 66.6217,
    x2: 50.3851,
    y2: 106.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37245,
    stopColor: "#FFED9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FDEC88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_840_2843",
    x1: 8.71828,
    y1: 68.3456,
    x2: 31.1368,
    y2: 87.5384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE56F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_840_2843",
    x1: 22.9572,
    y1: 61.7208,
    x2: 36.1422,
    y2: 105.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB7F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58163,
    stopColor: "#FFE660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77551,
    stopColor: "#FDE66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD73B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_840_2843",
    x1: 21.128,
    y1: 56.9255,
    x2: 37.337,
    y2: 108.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFBF21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30612,
    stopColor: "#F5D254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56122,
    stopColor: "#E4BA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B57129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_840_2843",
    x1: 5.77337,
    y1: 86.4883,
    x2: 55.2217,
    y2: 86.4883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37245,
    stopColor: "#FFEC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FDEC87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBE34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_840_2843",
    x1: 23.4609,
    y1: -0.00224198,
    x2: 46.8971,
    y2: -0.00224198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_840_2843",
    x1: 28.1484,
    y1: -0.00224266,
    x2: 51.5846,
    y2: -0.00224266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_840_2843",
    x1: 32.8359,
    y1: -0.00224198,
    x2: 56.2721,
    y2: -0.00224198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C56A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B388F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_840_2843",
    x1: 39.865,
    y1: 45.5767,
    x2: 39.865,
    y2: 57.8457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63775,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82143,
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_840_2843",
    x1: 25.1724,
    y1: 107.951,
    x2: 25.1724,
    y2: 105.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_840_2843",
    x1: 26.007,
    y1: 105.385,
    x2: 26.007,
    y2: 102.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_840_2843",
    x1: 22.5123,
    y1: 106.892,
    x2: 22.5123,
    y2: 104.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_840_2843",
    x1: 23.7101,
    y1: 104.608,
    x2: 23.7101,
    y2: 101.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_840_2843",
    x1: 20.0406,
    y1: 105.555,
    x2: 20.0406,
    y2: 103.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_840_2843",
    x1: 21.5769,
    y1: 103.519,
    x2: 21.5769,
    y2: 100.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_840_2843",
    x1: 17.7359,
    y1: 103.922,
    x2: 17.7359,
    y2: 102.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_840_2843",
    x1: 19.593,
    y1: 102.174,
    x2: 19.593,
    y2: 99.3574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_840_2843",
    x1: 15.6897,
    y1: 102.061,
    x2: 15.6897,
    y2: 100.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_840_2843",
    x1: 17.8096,
    y1: 100.544,
    x2: 17.8096,
    y2: 97.8184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_840_2843",
    x1: 13.8851,
    y1: 99.9608,
    x2: 13.8851,
    y2: 98.3633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_840_2843",
    x1: 16.2824,
    y1: 98.6881,
    x2: 16.2824,
    y2: 96.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_840_2843",
    x1: 12.3659,
    y1: 97.6652,
    x2: 12.3659,
    y2: 96.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_840_2843",
    x1: 14.9989,
    y1: 96.6184,
    x2: 14.9989,
    y2: 94.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_840_2843",
    x1: 11.1827,
    y1: 95.201,
    x2: 11.1827,
    y2: 93.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_840_2843",
    x1: 13.9932,
    y1: 94.3795,
    x2: 13.9932,
    y2: 92.2207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_840_2843",
    x1: 10.3251,
    y1: 92.6106,
    x2: 10.3251,
    y2: 90.9395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_840_2843",
    x1: 13.2782,
    y1: 92.0251,
    x2: 13.2782,
    y2: 90.1074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_840_2843",
    x1: 9.84112,
    y1: 89.9359,
    x2: 9.84112,
    y2: 88.1895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_840_2843",
    x1: 12.8553,
    y1: 89.6066,
    x2: 12.8553,
    y2: 87.8906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_840_2843",
    x1: 9.70027,
    y1: 87.2291,
    x2: 9.70027,
    y2: 85.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_840_2843",
    x1: 12.7282,
    y1: 87.1603,
    x2: 12.7282,
    y2: 85.5742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_840_2843",
    x1: 9.91978,
    y1: 84.5356,
    x2: 9.91978,
    y2: 82.5332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_840_2843",
    x1: 12.8986,
    y1: 84.7238,
    x2: 12.8986,
    y2: 83.2227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_840_2843",
    x1: 10.5066,
    y1: 81.8929,
    x2: 10.5066,
    y2: 79.6895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_840_2843",
    x1: 13.4003,
    y1: 82.3486,
    x2: 13.4003,
    y2: 80.8984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_840_2843",
    x1: 11.4563,
    y1: 79.3584,
    x2: 11.4563,
    y2: 76.9414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_840_2843",
    x1: 14.1895,
    y1: 80.0743,
    x2: 14.1895,
    y2: 78.6367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_840_2843",
    x1: 12.7301,
    y1: 76.9779,
    x2: 12.7301,
    y2: 74.3652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_840_2843",
    x1: 15.2653,
    y1: 77.9359,
    x2: 15.2653,
    y2: 76.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_840_2843",
    x1: 14.2911,
    y1: 74.7734,
    x2: 14.2911,
    y2: 71.9941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_840_2843",
    x1: 16.5985,
    y1: 75.9807,
    x2: 16.5985,
    y2: 74.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_840_2843",
    x1: 16.5986,
    y1: 73.8454,
    x2: 16.5986,
    y2: 71.2695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_840_2843",
    x1: 4.48284,
    y1: 71.1256,
    x2: 28.4482,
    y2: 113.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_840_2843",
    x1: 6.30994,
    y1: 70.0764,
    x2: 30.2752,
    y2: 112.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_840_2843",
    x1: 2.89886,
    y1: 72.0304,
    x2: 26.864,
    y2: 113.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_840_2843",
    x1: 4.96556,
    y1: 70.8464,
    x2: 28.931,
    y2: 112.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_840_2843",
    x1: 1.58688,
    y1: 72.7874,
    x2: 25.5521,
    y2: 114.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_840_2843",
    x1: 3.86414,
    y1: 71.4846,
    x2: 27.8295,
    y2: 113.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_840_2843",
    x1: 0.5254,
    y1: 73.3824,
    x2: 24.4909,
    y2: 115.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_840_2843",
    x1: 2.9859,
    y1: 71.9837,
    x2: 26.9514,
    y2: 113.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_840_2843",
    x1: -0.210683,
    y1: 73.8043,
    x2: 23.7547,
    y2: 115.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_840_2843",
    x1: 2.35485,
    y1: 72.341,
    x2: 26.3205,
    y2: 114.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_840_2843",
    x1: -0.655783,
    y1: 74.0585,
    x2: 23.3096,
    y2: 115.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_840_2843",
    x1: 1.97116,
    y1: 72.5637,
    x2: 25.9367,
    y2: 114.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_840_2843",
    x1: -0.776234,
    y1: 74.1324,
    x2: 23.1891,
    y2: 116.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_840_2843",
    x1: 1.85232,
    y1: 72.6309,
    x2: 25.8178,
    y2: 114.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_840_2843",
    x1: -0.600315,
    y1: 74.0265,
    x2: 23.3649,
    y2: 115.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_840_2843",
    x1: 1.99979,
    y1: 72.5453,
    x2: 25.9653,
    y2: 114.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_840_2843",
    x1: -0.0903061,
    y1: 73.7416,
    x2: 23.875,
    y2: 115.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_840_2843",
    x1: 2.41488,
    y1: 72.3043,
    x2: 26.3805,
    y2: 114.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_840_2843",
    x1: 0.73412,
    y1: 73.2759,
    x2: 24.6993,
    y2: 115.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_840_2843",
    x1: 3.09028,
    y1: 71.9158,
    x2: 27.0557,
    y2: 113.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_840_2843",
    x1: 1.80156,
    y1: 72.6559,
    x2: 25.7669,
    y2: 114.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_840_2843",
    x1: 4.01491,
    y1: 71.3878,
    x2: 27.9805,
    y2: 113.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_840_2843",
    x1: 3.14473,
    y1: 71.8907,
    x2: 27.1102,
    y2: 113.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_840_2843",
    x1: 5.17102,
    y1: 70.7331,
    x2: 29.1363,
    y2: 112.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_840_2843",
    x1: 4.72963,
    y1: 70.9851,
    x2: 28.695,
    y2: 112.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_840_2843",
    x1: 6.52625,
    y1: 69.9594,
    x2: 30.4916,
    y2: 111.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_840_2843",
    x1: 6.5381,
    y1: 69.9536,
    x2: 30.5032,
    y2: 111.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_840_2843",
    x1: 8.07291,
    y1: 69.0754,
    x2: 32.0384,
    y2: 111.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_840_2843",
    x1: 8.51769,
    y1: 68.8197,
    x2: 32.4832,
    y2: 110.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_840_2843",
    x1: 9.78595,
    y1: 68.0995,
    x2: 33.7512,
    y2: 110.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_840_2843",
    x1: 10.6592,
    y1: 67.5908,
    x2: 34.6248,
    y2: 109.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_840_2843",
    x1: 11.632,
    y1: 67.046,
    x2: 35.5974,
    y2: 108.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_840_2843",
    x1: 12.9119,
    y1: 66.3048,
    x2: 36.8773,
    y2: 108.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_840_2843",
    x1: 35.8364,
    y1: 107.951,
    x2: 35.8364,
    y2: 105.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_840_2843",
    x1: 34.9914,
    y1: 105.385,
    x2: 34.9914,
    y2: 102.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_840_2843",
    x1: 38.4732,
    y1: 106.892,
    x2: 38.4732,
    y2: 104.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_840_2843",
    x1: 37.2648,
    y1: 104.608,
    x2: 37.2648,
    y2: 101.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_840_2843",
    x1: 40.9469,
    y1: 105.555,
    x2: 40.9469,
    y2: 103.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_840_2843",
    x1: 39.4128,
    y1: 103.519,
    x2: 39.4128,
    y2: 100.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_840_2843",
    x1: 43.2515,
    y1: 103.922,
    x2: 43.2515,
    y2: 102.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_840_2843",
    x1: 41.4055,
    y1: 102.174,
    x2: 41.4055,
    y2: 99.3574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_840_2843",
    x1: 45.2991,
    y1: 102.061,
    x2: 45.2991,
    y2: 100.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_840_2843",
    x1: 43.1768,
    y1: 100.544,
    x2: 43.1768,
    y2: 97.8184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_840_2843",
    x1: 47.1195,
    y1: 99.9608,
    x2: 47.1195,
    y2: 98.3633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_840_2843",
    x1: 44.7121,
    y1: 98.6881,
    x2: 44.7121,
    y2: 96.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_840_2843",
    x1: 48.6237,
    y1: 97.6652,
    x2: 48.6237,
    y2: 96.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_840_2843",
    x1: 45.9911,
    y1: 96.6184,
    x2: 45.9911,
    y2: 94.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_840_2843",
    x1: 49.8234,
    y1: 95.201,
    x2: 49.8234,
    y2: 93.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_840_2843",
    x1: 46.9854,
    y1: 94.3795,
    x2: 46.9854,
    y2: 92.2207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_840_2843",
    x1: 50.661,
    y1: 92.6106,
    x2: 50.661,
    y2: 90.9395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_840_2843",
    x1: 47.7001,
    y1: 92.0251,
    x2: 47.7001,
    y2: 90.1074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_840_2843",
    x1: 51.1458,
    y1: 89.9359,
    x2: 51.1458,
    y2: 88.1895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_840_2843",
    x1: 48.1366,
    y1: 89.6066,
    x2: 48.1366,
    y2: 87.8906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_840_2843",
    x1: 51.294,
    y1: 87.2291,
    x2: 51.294,
    y2: 85.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_840_2843",
    x1: 48.2672,
    y1: 87.1603,
    x2: 48.2672,
    y2: 85.5742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_840_2843",
    x1: 51.0682,
    y1: 84.5356,
    x2: 51.0682,
    y2: 82.5332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_840_2843",
    x1: 48.0783,
    y1: 84.7238,
    x2: 48.0783,
    y2: 83.2227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_840_2843",
    x1: 50.4754,
    y1: 81.8929,
    x2: 50.4754,
    y2: 79.6895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_840_2843",
    x1: 47.5878,
    y1: 82.3486,
    x2: 47.5878,
    y2: 80.8984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_840_2843",
    x1: 49.5266,
    y1: 79.3584,
    x2: 49.5266,
    y2: 76.9414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_840_2843",
    x1: 46.7988,
    y1: 80.0743,
    x2: 46.7988,
    y2: 78.6367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_840_2843",
    x1: 48.2613,
    y1: 76.9779,
    x2: 48.2613,
    y2: 74.3652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_840_2843",
    x1: 45.7184,
    y1: 77.9359,
    x2: 45.7184,
    y2: 76.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_840_2843",
    x1: 46.6973,
    y1: 74.7734,
    x2: 46.6973,
    y2: 71.9941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_840_2843",
    x1: 44.3876,
    y1: 75.9807,
    x2: 44.3876,
    y2: 74.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_840_2843",
    x1: 44.3955,
    y1: 73.8454,
    x2: 44.3955,
    y2: 71.2695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_840_2843",
    x1: 56.5027,
    y1: 71.1254,
    x2: 32.5372,
    y2: 113.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_840_2843",
    x1: 54.6806,
    y1: 70.0764,
    x2: 30.7153,
    y2: 112.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_840_2843",
    x1: 58.1099,
    y1: 72.0305,
    x2: 34.1449,
    y2: 113.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_840_2843",
    x1: 56.0326,
    y1: 70.8464,
    x2: 32.0672,
    y2: 112.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_840_2843",
    x1: 59.4085,
    y1: 72.7873,
    x2: 35.4432,
    y2: 114.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_840_2843",
    x1: 57.1411,
    y1: 71.4846,
    x2: 33.1758,
    y2: 113.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_840_2843",
    x1: 60.4619,
    y1: 73.3825,
    x2: 36.4965,
    y2: 115.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_840_2843",
    x1: 58.0049,
    y1: 71.9837,
    x2: 34.0393,
    y2: 113.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_840_2843",
    x1: 61.1993,
    y1: 73.8045,
    x2: 37.2341,
    y2: 115.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_840_2843",
    x1: 58.6471,
    y1: 72.3412,
    x2: 34.6815,
    y2: 114.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_840_2843",
    x1: 61.6449,
    y1: 74.0584,
    x2: 37.6794,
    y2: 115.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_840_2843",
    x1: 59.0155,
    y1: 72.5638,
    x2: 35.0501,
    y2: 114.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_840_2843",
    x1: 61.7814,
    y1: 74.1324,
    x2: 37.8161,
    y2: 116.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_840_2843",
    x1: 59.1455,
    y1: 72.631,
    x2: 35.1802,
    y2: 114.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_840_2843",
    x1: 61.583,
    y1: 74.0264,
    x2: 37.6177,
    y2: 115.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_840_2843",
    x1: 58.9945,
    y1: 72.5453,
    x2: 35.0291,
    y2: 114.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_840_2843",
    x1: 61.0842,
    y1: 73.7415,
    x2: 37.1188,
    y2: 115.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_840_2843",
    x1: 58.579,
    y1: 72.3043,
    x2: 34.6134,
    y2: 114.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_840_2843",
    x1: 60.2762,
    y1: 73.2759,
    x2: 36.311,
    y2: 115.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_840_2843",
    x1: 57.8859,
    y1: 71.9158,
    x2: 33.9206,
    y2: 113.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_840_2843",
    x1: 59.1928,
    y1: 72.6559,
    x2: 35.2274,
    y2: 114.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_840_2843",
    x1: 56.9648,
    y1: 71.3878,
    x2: 32.9993,
    y2: 113.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_840_2843",
    x1: 57.8511,
    y1: 71.8907,
    x2: 33.8856,
    y2: 113.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_840_2843",
    x1: 55.8215,
    y1: 70.7331,
    x2: 31.8561,
    y2: 112.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_840_2843",
    x1: 56.2679,
    y1: 70.9851,
    x2: 32.3026,
    y2: 112.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_840_2843",
    x1: 54.4697,
    y1: 69.9595,
    x2: 30.5044,
    y2: 111.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_840_2843",
    x1: 54.4604,
    y1: 69.9536,
    x2: 30.4952,
    y2: 111.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_840_2843",
    x1: 52.9231,
    y1: 69.0755,
    x2: 28.9578,
    y2: 111.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_840_2843",
    x1: 52.4815,
    y1: 68.8197,
    x2: 28.516,
    y2: 110.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_840_2843",
    x1: 51.2134,
    y1: 68.0995,
    x2: 27.2482,
    y2: 110.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_840_2843",
    x1: 50.3292,
    y1: 67.5908,
    x2: 26.3636,
    y2: 109.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_840_2843",
    x1: 49.3698,
    y1: 67.046,
    x2: 25.4043,
    y2: 108.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_840_2843",
    x1: 48.0823,
    y1: 66.3048,
    x2: 24.1168,
    y2: 108.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_840_2843",
    x1: 20.6061,
    y1: 106.257,
    x2: 20.6061,
    y2: 73.8412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_840_2843",
    x1: 20.683,
    y1: 106.262,
    x2: 20.683,
    y2: 73.8412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46939,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_840_2843",
    x1: 40.3873,
    y1: 106.257,
    x2: 40.3873,
    y2: 73.8412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE872E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_840_2843",
    x1: 40.3001,
    y1: 106.262,
    x2: 40.3001,
    y2: 73.8412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46939,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_840_2843",
    x1: 25.7521,
    y1: 74.622,
    x2: 36.0435,
    y2: 96.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17283,
    stopColor: "#DFBF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44388,
    stopColor: "#E0BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#815020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_840_2843",
    x1: 23.4982,
    y1: 78.2267,
    x2: 38.0932,
    y2: 92.8217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53061,
    stopColor: "#FCEB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBD30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_2843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.9976,
    height: 117,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadle);
export default __webpack_public_path__ + "static/media/madle.f6766f89b5225c9f237a074f50b86a84.svg";
export { ForwardRef as ReactComponent };